webpackJsonp([66],{

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = getIsLoggedInO365;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserInfo;
/* unused harmony export getUserEmail */
/* harmony export (immutable) */ __webpack_exports__["a"] = getChangeSendMailResetPassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Lib__ = __webpack_require__(87);


function getIsLoggedIn(state) {
    var _getBSRSToken = Object(__WEBPACK_IMPORTED_MODULE_0_Lib__["h" /* getBSRSToken */])(),
        bsrsToken = _getBSRSToken.bsrsToken,
        role = _getBSRSToken.role;

    return bsrsToken && (role === "admin" || role === 'superadmin');
}

function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token;
}

function getUserInfo(state) {
    return state.auth.user;
}

function getUserEmail(state) {
    return state.auth.user.email;
}

function getChangeSendMailResetPassword(state) {
    return state.sendMailResetPassword;
}

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return LOGOUT; });
/* unused harmony export SET_ERROR */
/* unused harmony export O365_REGISTER_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return O365_REGISTER_SUCCESS; });
/* unused harmony export O365_REGISTER_FAILURE */
/* unused harmony export O365_LOAD_EVENTS_REQUEST */
/* unused harmony export O365_LOAD_EVENTS_SUCCESS */
/* unused harmony export O365_LOAD_EVENTS_FAILURE */
/* unused harmony export O365_LOAD_EVENT_REQUEST */
/* unused harmony export O365_LOAD_EVENT_SUCCESS */
/* unused harmony export O365_LOAD_EVENT_FAILURE */
/* unused harmony export O365_LOAD_EDIT_EVENT_REQUEST */
/* unused harmony export O365_LOAD_EDIT_EVENT_SUCCESS */
/* unused harmony export O365_LOAD_EDIT_EVENT_FAILURE */
/* unused harmony export O365_LOAD_USER_INFO_REQUEST */
/* unused harmony export O365_LOAD_USER_INFO_SUCCESS */
/* unused harmony export O365_LOAD_USER_INFO_FAILURE */
/* unused harmony export O365_CREATE_EVENT_REQUEST */
/* unused harmony export O365_CREATE_EVENT_SUCCESS */
/* unused harmony export O365_CREATE_EVENT_FAILURE */
/* unused harmony export O365_UPDATE_EVENT_REQUEST */
/* unused harmony export O365_UPDATE_EVENT_SUCCESS */
/* unused harmony export O365_UPDATE_EVENT_FAILURE */
/* unused harmony export O365_DELETE_EVENT_REQUEST */
/* unused harmony export O365_DELETE_EVENT_SUCCESS */
/* unused harmony export O365_DELETE_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* unused harmony export PROFILE_LOGIN_REQUEST */
/* unused harmony export PROFILE_LOGIN_SUCCESS */
/* unused harmony export PROFILE_LOGIN_FAILURE */
/* unused harmony export O365_ACCEPT_EVENT_REQUEST */
/* unused harmony export O365_ACCEPT_EVENT_SUCCESS */
/* unused harmony export O365_ACCEPT_EVENT_FAILURE */
/* unused harmony export O365_TENTATIVE_EVENT_REQUEST */
/* unused harmony export O365_TENTATIVE_EVENT_SUCCESS */
/* unused harmony export O365_TENTATIVE_EVENT_FAILURE */
/* unused harmony export O365_DECLINE_EVENT_REQUEST */
/* unused harmony export O365_DECLINE_EVENT_SUCCESS */
/* unused harmony export O365_DECLINE_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* unused harmony export O365_CHECKOUT_EVENT_REQUEST */
/* unused harmony export O365_CHECKOUT_EVENT_SUCCESS */
/* unused harmony export O365_CHECKOUT_EVENT_FAILURE */
/* unused harmony export O365_LOAD_PEOPLE_REQUEST */
/* unused harmony export O365_LOAD_PEOPLE_SUCCESS */
/* unused harmony export O365_LOAD_PEOPLE_FAILURE */
/* unused harmony export O365_LOAD_LOCATION_REQUEST */
/* unused harmony export O365_LOAD_LOCATION_SUCCESS */
/* unused harmony export O365_LOAD_LOCATION_FAILURE */
/* unused harmony export O365_SEARCH_SLOT_REQUEST */
/* unused harmony export O365_SEARCH_SLOT_SUCCESS */
/* unused harmony export O365_SEARCH_SLOT_FAILURE */
/* unused harmony export CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID */
/* unused harmony export CORE_INTEGRATION_O365_GO_ADMIN_CONSENT */
/* unused harmony export CORE_INTEGRATION_O365_GO_SAVE_DATA */
/* unused harmony export CORE_INTEGRATION_O365_ADD_CLIENT_ID */
/* unused harmony export CORE_INTEGRATION_O365_ADMIN_CONSENT */
/* unused harmony export CORE_INTEGRATION_O365_REQUEST */
/* unused harmony export CORE_INTEGRATION_O365_SUCCESS */
/* unused harmony export CORE_INTEGRATION_O365_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return CORE_LOAD_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return CORE_LOAD_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return CORE_LOAD_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_FIND_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_FIND_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_FIND_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return CORE_UPDATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return CORE_UPDATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return CORE_UPDATE_ROOM_FAILURE; });
/* unused harmony export O365_LOAD_ROOM_REQUEST */
/* unused harmony export O365_LOAD_ROOM_SUCCESS */
/* unused harmony export O365_LOAD_ROOM_FAILURE */
/* unused harmony export O365_LOAD_ROOM_INFO_REQUEST */
/* unused harmony export O365_LOAD_ROOM_INFO_SUCCESS */
/* unused harmony export O365_LOAD_ROOM_INFO_FAILURE */
/* unused harmony export BSRS_SERVICE_TOKEN_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BSRS_SERVICE_TOKEN_SUCCESS; });
/* unused harmony export BSRS_SERVICE_TOKEN_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_LOAD_ALLROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_LOAD_ALLROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_LOAD_ALLROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return CORE_LOAD_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return CORE_LOAD_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return CORE_LOAD_REPORT_FAILURE; });
/* unused harmony export CORE_LOAD_LOCATIONS_REPORT_REQUEST */
/* unused harmony export CORE_LOAD_LOCATIONS_REPORT_SUCCESS */
/* unused harmony export CORE_LOAD_LOCATIONS_REPORT_FAILURE */
/* unused harmony export CORE_ADD_USER_REQUEST */
/* unused harmony export CORE_ADD_USER_SUCCESS */
/* unused harmony export CORE_ADD_USER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return CORE_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return CORE_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return CORE_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return CORE_LOAD_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return CORE_LOAD_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return CORE_LOAD_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_DELETE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_DELETE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_DELETE_USER_FAILURE; });
/* unused harmony export CORE_USER_CHANGEPASS_REQUEST */
/* unused harmony export CORE_USER_CHANGEPASS_SUCCESS */
/* unused harmony export CORE_USER_CHANGEPASS_FAILURE */
/* unused harmony export CORE_EDIT_USER_REQUEST */
/* unused harmony export CORE_EDIT_USER_SUCCESS */
/* unused harmony export CORE_EDIT_USER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_CREATE_SYNC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_CREATE_SYNC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_CREATE_SYNC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_CREATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_EDIT_SYNC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_EDIT_SYNC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_EDIT_SYNC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return CORE_LOAD_SYNC_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return CORE_LOAD_SYNC_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return CORE_LOAD_SYNC_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return CORE_LOAD_SYSTEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return CORE_LOAD_SYSTEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return CORE_LOAD_SYSTEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return CORE_LOAD_LOCAL_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return CORE_LOAD_LOCAL_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return CORE_LOAD_LOCAL_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_DELETE_LOCAL_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_DELETE_LOCAL_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_DELETE_LOCAL_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_LOAD_ALL_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_LOAD_ALL_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_LOAD_ALL_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_LOAD_ALL_AMENITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_LOAD_ALL_AMENITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_LOAD_ALL_AMENITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_CREATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_CREATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_CREATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_EDIT_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_EDIT_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_EDIT_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CREATE_DISABLE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CREATE_DISABLE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CREATE_DISABLE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_EDIT_DISABLE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_EDIT_DISABLE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_EDIT_DISABLE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_DELETE_DISABLE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_DELETE_DISABLE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_DELETE_DISABLE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return CORE_LOAD_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return CORE_LOAD_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return CORE_LOAD_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_DELETE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_DELETE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_DELETE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return CORE_LOAD_QRCODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return CORE_LOAD_QRCODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return CORE_LOAD_QRCODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CHANGE_QRCODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHANGE_QRCODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CHANGE_QRCODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return CORE_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return CORE_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return CORE_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_EDIT_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_EDIT_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_EDIT_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_DELETE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_DELETE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_DELETE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_LOAD_ALL_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_LOAD_ALL_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_LOAD_ALL_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return CORE_LOAD_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return CORE_LOAD_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return CORE_LOAD_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_LOAD_ALL_BUILDINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_LOAD_ALL_BUILDINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_LOAD_ALL_BUILDINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_LOAD_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_LOAD_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_LOAD_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CREATE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CREATE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CREATE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_EDIT_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_EDIT_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_EDIT_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_DELETE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_DELETE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_DELETE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_ALL_FBS_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_LOAD_ALL_FBS_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_EDIT_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_EDIT_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_EDIT_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return CORE_LOAD_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return CORE_LOAD_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return CORE_LOAD_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_DELETE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_DELETE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_DELETE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_LOAD_ALL_HOLIDAYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_LOAD_ALL_HOLIDAYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_LOAD_ALL_HOLIDAYS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return CORE_LOAD_HOLIDAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return CORE_LOAD_HOLIDAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return CORE_LOAD_HOLIDAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CREATE_HOLIDAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CREATE_HOLIDAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_HOLIDAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_EDIT_HOLIDAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_EDIT_HOLIDAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_EDIT_HOLIDAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_DELETE_HOLIDAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_DELETE_HOLIDAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_DELETE_HOLIDAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_LOAD_DISABLE_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return CORE_LOAD_DISABLE_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_LOAD_DISABLE_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return CORE_LOAD_DISABLE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return CORE_LOAD_DISABLE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return CORE_LOAD_DISABLE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CREATE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CREATE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CREATE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_EDIT_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_EDIT_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_EDIT_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_LOAD_ALL_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_LOAD_ALL_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_LOAD_ALL_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_LOAD_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_LOAD_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_LOAD_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_DELETE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_DELETE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_DELETE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return CORE_LOAD_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return CORE_LOAD_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return CORE_LOAD_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return CORE_UPDATE_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return CORE_UPDATE_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return CORE_UPDATE_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_CREATE_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_CREATE_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_CREATE_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_EDIT_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_EDIT_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_EDIT_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_LOAD_ALL_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_LOAD_ALL_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_LOAD_ALL_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return CORE_LOAD_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return CORE_LOAD_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return CORE_LOAD_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_DELETE_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_DELETE_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_DELETE_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return CORE_LOAD_EXECUTIVE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return CORE_LOAD_EXECUTIVE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return CORE_LOAD_EXECUTIVE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return CORE_LOAD_EVENTREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return CORE_LOAD_EVENTREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return CORE_LOAD_EVENTREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_LOAD_ALL_ROOMFORMATS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_LOAD_ALL_ROOMFORMATS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_LOAD_ALL_ROOMFORMATS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CREATE_ROOMFORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_CREATE_ROOMFORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CREATE_ROOMFORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return CORE_LOAD_ROOMFORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return CORE_LOAD_ROOMFORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return CORE_LOAD_ROOMFORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_EDIT_ROOMFORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_EDIT_ROOMFORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_EDIT_ROOMFORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_DELETE_ROOMFORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_DELETE_ROOMFORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_DELETE_ROOMFORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return CORE_LOAD_USERFILTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return CORE_LOAD_USERFILTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return CORE_LOAD_USERFILTER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_CANCEL_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CANCEL_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_CANCEL_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_FILTER_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_FILTER_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_FILTER_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_DOWN_SEQ_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_DOWN_SEQ_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_DOWN_SEQ_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return CORE_UP_SEQ_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return CORE_UP_SEQ_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return CORE_UP_SEQ_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_DOWN_SEQ_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_DOWN_SEQ_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_DOWN_SEQ_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return CORE_UP_SEQ_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return CORE_UP_SEQ_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return CORE_UP_SEQ_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_DOWN_SEQ_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_DOWN_SEQ_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_DOWN_SEQ_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return CORE_UP_SEQ_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return CORE_UP_SEQ_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return CORE_UP_SEQ_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_FILTER_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_FILTER_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_FILTER_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_FILTER_ROOMFORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_FILTER_ROOMFORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_FILTER_ROOMFORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_FILTER_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_FILTER_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_FILTER_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_FILTER_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_FILTER_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_FILTER_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_FILTER_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_FILTER_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_FILTER_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_LOAD_ADMINREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_LOAD_ADMINREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_LOAD_ADMINREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return CORE_SEARCH_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return CORE_SEARCH_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return CORE_SEARCH_EVENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return CORE_LOAD_PRIVATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return CORE_LOAD_PRIVATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return CORE_LOAD_PRIVATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return CORE_REOPEN_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return CORE_REOPEN_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return CORE_REOPEN_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return CORE_REQUEST_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return CORE_REQUEST_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return CORE_REQUEST_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_IMPORT_USER_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_IMPORT_USER_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_IMPORT_USER_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_LOAD_ALL_DEPARTMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_LOAD_ALL_DEPARTMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_LOAD_ALL_DEPARTMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return CORE_LOAD_SEARCH_DEPARTMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return CORE_LOAD_SEARCH_DEPARTMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return CORE_LOAD_SEARCH_DEPARTMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_LOAD_DEPARTMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_LOAD_DEPARTMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_LOAD_DEPARTMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_DELETE_DEPARTMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_DELETE_DEPARTMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_DELETE_DEPARTMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_LOAD_ALL_ROOMTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_LOAD_ALL_ROOMTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_LOAD_ALL_ROOMTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return CORE_LOAD_SEARCH_ROOMTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return CORE_LOAD_SEARCH_ROOMTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return CORE_LOAD_SEARCH_ROOMTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return CORE_LOAD_ROOMTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return CORE_LOAD_ROOMTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return CORE_LOAD_ROOMTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_DELETE_ROOMTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_DELETE_ROOMTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_DELETE_ROOMTYPE_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';
var O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST';
var O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS';
var O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE';

var O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST';
var O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS';
var O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE';

var O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST';
var O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS';
var O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE';

var O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST';
var O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS';
var O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE';

var O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST';
var O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS';
var O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE';

var O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST';
var O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS';
var O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE';

var O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST';
var O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS';
var O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE';

var O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST';
var O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS';
var O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var PROFILE_LOGIN_REQUEST = 'PROFILE_LOGIN_REQUEST';
var PROFILE_LOGIN_SUCCESS = 'PROFILE_LOGIN_SUCCESS';
var PROFILE_LOGIN_FAILURE = 'PROFILE_LOGIN_FAILURE';

var O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST';
var O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS';
var O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE';

var O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST';
var O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS';
var O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE';

var O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST';
var O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS';
var O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST';
var O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS';
var O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE';

var O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST';
var O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS';
var O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE';

var O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST';
var O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS';
var O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE';

var O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST';
var O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS';
var O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE';

var CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_GO_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_GO_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_GO_SAVE_DATA = 'CORE_INTEGRATION_O365_GO_SAVE_DATA';

var CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST';
var CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS';
var CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE';

var CORE_LOAD_ROOM_REQUEST = 'CORE_LOAD_ROOM_REQUEST';
var CORE_LOAD_ROOM_SUCCESS = ' CORE_LOAD_ROOM_SUCCESS';
var CORE_LOAD_ROOM_FAILURE = ' CORE_LOAD_ROOM_FAILURE';

var CORE_FIND_ROOM_REQUEST = 'CORE_FIND_ROOM_REQUEST';
var CORE_FIND_ROOM_SUCCESS = ' CORE_FIND_ROOM_SUCCESS';
var CORE_FIND_ROOM_FAILURE = ' CORE_FIND_ROOM_FAILURE';

var CORE_UPDATE_ROOM_REQUEST = 'CORE_UPDATE_ROOM_REQUEST';
var CORE_UPDATE_ROOM_SUCCESS = ' CORE_UPDATE_ROOM_SUCCESS';
var CORE_UPDATE_ROOM_FAILURE = ' CORE_UPDATE_ROOM_FAILURE';

var O365_LOAD_ROOM_REQUEST = 'O365_LOAD_ROOM_REQUEST';
var O365_LOAD_ROOM_SUCCESS = 'O365_LOAD_ROOM_SUCCESS';
var O365_LOAD_ROOM_FAILURE = 'O365_LOAD_ROOM_FAILURE';

var O365_LOAD_ROOM_INFO_REQUEST = 'O365_LOAD_ROOM_INFO_REQUEST';
var O365_LOAD_ROOM_INFO_SUCCESS = 'O365_LOAD_ROOM_INFO_SUCCESS';
var O365_LOAD_ROOM_INFO_FAILURE = 'O365_LOAD_ROOM_INFO_FAILURE';

var BSRS_SERVICE_TOKEN_REQUEST = 'BSRS_SERVICE_TOKEN_REQUEST';
var BSRS_SERVICE_TOKEN_SUCCESS = 'BSRS_SERVICE_TOKEN_SUCCESS';
var BSRS_SERVICE_TOKEN_FAILURE = 'BSRS_SERVICE_TOKEN_FAILURE';

var CORE_LOAD_ALLROOM_REQUEST = 'CORE_LOAD_ALLROOM_REQUEST';
var CORE_LOAD_ALLROOM_SUCCESS = 'CORE_LOAD_ALLROOM_SUCCESS';
var CORE_LOAD_ALLROOM_FAILURE = 'CORE_LOAD_ALLROOM_FAILURE';

var CORE_LOAD_REPORT_REQUEST = 'CORE_LOAD_REPORT_REQUEST';
var CORE_LOAD_REPORT_SUCCESS = 'CORE_LOAD_REPORT_SUCCESS';
var CORE_LOAD_REPORT_FAILURE = 'CORE_LOAD_REPORT_FAILURE';

var CORE_LOAD_LOCATIONS_REPORT_REQUEST = 'CORE_LOAD_LOCATIONS_REPORT_REQUEST';
var CORE_LOAD_LOCATIONS_REPORT_SUCCESS = 'CORE_LOAD_LOCATIONS_REPORT_SUCCESS';
var CORE_LOAD_LOCATIONS_REPORT_FAILURE = 'CORE_LOAD_LOCATIONS_REPORT_FAILURE';

var CORE_ADD_USER_REQUEST = 'CORE_ADD_USER_REQUEST';
var CORE_ADD_USER_SUCCESS = 'CORE_ADD_USER_SUCCESS';
var CORE_ADD_USER_FAILURE = 'CORE_ADD_USER_FAILURE';

var CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST';
var CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS';
var CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE';

var CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST';
var CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS';
var CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

var CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST';
var CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS';
var CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE';

var CORE_USER_CHANGEPASS_REQUEST = 'CORE_USER_CHANGEPASS_REQUEST';
var CORE_USER_CHANGEPASS_SUCCESS = 'CORE_USER_CHANGEPASS_SUCCESS';
var CORE_USER_CHANGEPASS_FAILURE = 'CORE_USER_CHANGEPASS_FAILURE';

var CORE_EDIT_USER_REQUEST = 'CORE_EDIT_USER_REQUEST';
var CORE_EDIT_USER_SUCCESS = 'CORE_EDIT_USER_SUCCESS';
var CORE_EDIT_USER_FAILURE = 'CORE_EDIT_USER_FAILURE';

var CORE_CREATE_SYNC_REQUEST = 'CORE_CREATE_SYNC_REQUEST';
var CORE_CREATE_SYNC_SUCCESS = 'CORE_CREATE_SYNC_SUCCESS';
var CORE_CREATE_SYNC_FAILURE = 'CORE_CREATE_SYNC_FAILURE';

var CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST';
var CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS';
var CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE';

var CORE_EDIT_SYNC_REQUEST = 'CORE_EDIT_SYNC_REQUEST';
var CORE_EDIT_SYNC_SUCCESS = 'CORE_EDIT_SYNC_SUCCESS';
var CORE_EDIT_SYNC_FAILURE = 'CORE_EDIT_SYNC_FAILURE';

var CORE_LOAD_SYNC_USER_REQUEST = 'CORE_LOAD_SYNC_USER_REQUEST';
var CORE_LOAD_SYNC_USER_SUCCESS = 'CORE_LOAD_SYNC_USER_SUCCESS';
var CORE_LOAD_SYNC_USER_FAILURE = 'CORE_LOAD_SYNC_USER_FAILURE';

var CORE_LOAD_SYSTEM_REQUEST = 'CORE_LOAD_SYSTEM_REQUEST';
var CORE_LOAD_SYSTEM_SUCCESS = 'CORE_LOAD_SYSTEM_SUCCESS';
var CORE_LOAD_SYSTEM_FAILURE = 'CORE_LOAD_SYSTEM_FAILURE';

var CORE_LOAD_LOCAL_USERS_REQUEST = 'CORE_LOAD_LOCAL_USERS_REQUEST';
var CORE_LOAD_LOCAL_USERS_SUCCESS = 'CORE_LOAD_LOCAL_USERS_SUCCESS';
var CORE_LOAD_LOCAL_USERS_FAILURE = 'CORE_LOAD_LOCAL_USERS_FAILURE';

var CORE_DELETE_LOCAL_USERS_REQUEST = 'CORE_DELETE_LOCAL_USERS_REQUEST';
var CORE_DELETE_LOCAL_USERS_SUCCESS = 'CORE_DELETE_LOCAL_USERS_SUCCESS';
var CORE_DELETE_LOCAL_USERS_FAILURE = 'CORE_DELETE_LOCAL_USERS_FAILURE';

var CORE_LOAD_ALL_FLOOR_REQUEST = 'CORE_LOAD_ALL_FLOOR_REQUEST';
var CORE_LOAD_ALL_FLOOR_SUCCESS = 'CORE_LOAD_ALL_FLOOR_SUCCESS';
var CORE_LOAD_ALL_FLOOR_FAILURE = 'CORE_LOAD_ALL_FLOOR_FAILURE';

var CORE_LOAD_ALL_AMENITIES_REQUEST = 'CORE_LOAD_ALL_AMENITIES_REQUEST';
var CORE_LOAD_ALL_AMENITIES_SUCCESS = 'CORE_LOAD_ALL_AMENITIES_SUCCESS';
var CORE_LOAD_ALL_AMENITIES_FAILURE = 'CORE_LOAD_ALL_AMENITIES_FAILURE';

var CORE_CREATE_ROOM_REQUEST = 'CORE_CREATE_ROOM_REQUEST';
var CORE_CREATE_ROOM_SUCCESS = 'CORE_CREATE_ROOM_SUCCESS';
var CORE_CREATE_ROOM_FAILURE = 'CORE_CREATE_ROOM_FAILURE';

var CORE_EDIT_ROOM_REQUEST = 'CORE_EDIT_ROOM_REQUEST';
var CORE_EDIT_ROOM_SUCCESS = 'CORE_EDIT_ROOM_SUCCESS';
var CORE_EDIT_ROOM_FAILURE = 'CORE_EDIT_ROOM_FAILURE';

var CORE_CREATE_DISABLE_ROOM_REQUEST = 'CORE_CREATE_DISABLE_ROOM_REQUEST';
var CORE_CREATE_DISABLE_ROOM_SUCCESS = 'CORE_CREATE_DISABLE_ROOM_SUCCESS';
var CORE_CREATE_DISABLE_ROOM_FAILURE = 'CORE_CREATE_DISABLE_ROOM_FAILURE';

var CORE_EDIT_DISABLE_ROOM_REQUEST = 'CORE_EDIT_DISABLE_ROOM_REQUEST';
var CORE_EDIT_DISABLE_ROOM_SUCCESS = 'CORE_EDIT_DISABLE_ROOM_SUCCESS';
var CORE_EDIT_DISABLE_ROOM_FAILURE = 'CORE_EDIT_DISABLE_ROOM_FAILURE';

var CORE_DELETE_DISABLE_ROOM_REQUEST = 'CORE_DELETE_DISABLE_ROOM_REQUEST';
var CORE_DELETE_DISABLE_ROOM_SUCCESS = 'CORE_DELETE_DISABLE_ROOM_SUCCESS';
var CORE_DELETE_DISABLE_ROOM_FAILURE = 'CORE_DELETE_DISABLE_ROOM_FAILURE';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var CORE_LOAD_ROLE_REQUEST = 'CORE_LOAD_ROLE_REQUEST';
var CORE_LOAD_ROLE_SUCCESS = 'CORE_LOAD_ROLE_SUCCESS';
var CORE_LOAD_ROLE_FAILURE = 'CORE_LOAD_ROLE_FAILURE';

var CORE_DELETE_ROOM_REQUEST = 'CORE_DELETE_ROOM_REQUEST';
var CORE_DELETE_ROOM_SUCCESS = 'CORE_DELETE_ROOM_SUCCESS';
var CORE_DELETE_ROOM_FAILURE = 'CORE_DELETE_ROOM_FAILURE';

var CORE_LOAD_QRCODE_REQUEST = 'CORE_LOAD_QRCODE_REQUEST';
var CORE_LOAD_QRCODE_SUCCESS = 'CORE_LOAD_QRCODE_SUCCESS';
var CORE_LOAD_QRCODE_FAILURE = 'CORE_LOAD_QRCODE_FAILURE';

var CORE_CHANGE_QRCODE_REQUEST = 'CORE_CHANGE_QRCODE_REQUEST';
var CORE_CHANGE_QRCODE_SUCCESS = 'CORE_CHANGE_QRCODE_SUCCESS';
var CORE_CHANGE_QRCODE_FAILURE = 'CORE_CHANGE_QRCODE_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_RESET_PASSWORD_REQUEST = 'CORE_RESET_PASSWORD_REQUEST';
var CORE_RESET_PASSWORD_SUCCESS = 'CORE_RESET_PASSWORD_SUCCESS';
var CORE_RESET_PASSWORD_FAILURE = 'CORE_RESET_PASSWORD_FAILURE';

var CORE_CREATE_FBS_REQUEST = 'CORE_CREATE_FBS_REQUEST';
var CORE_CREATE_FBS_SUCCESS = 'CORE_CREATE_FBS_SUCCESS';
var CORE_CREATE_FBS_FAILURE = 'CORE_CREATE_FBS_FAILURE';

var CORE_EDIT_FBS_REQUEST = 'CORE_EDIT_FBS_REQUEST';
var CORE_EDIT_FBS_SUCCESS = 'CORE_EDIT_FBS_SUCCESS';
var CORE_EDIT_FBS_FAILURE = 'CORE_EDIT_FBS_FAILURE';

var CORE_DELETE_FBS_REQUEST = 'CORE_DELETE_FBS_REQUEST';
var CORE_DELETE_FBS_SUCCESS = 'CORE_DELETE_FBS_SUCCESS';
var CORE_DELETE_FBS_FAILURE = 'CORE_DELETE_FBS_FAILURE';

var CORE_LOAD_ALL_FBS_REQUEST = 'CORE_LOAD_ALL_FBS_REQUEST';
var CORE_LOAD_ALL_FBS_SUCCESS = 'CORE_LOAD_ALL_FBS_SUCCESS';
var CORE_LOAD_ALL_FBS_FAILURE = 'CORE_LOAD_ALL_FBS_FAILURE';

var CORE_LOAD_FBS_REQUEST = 'CORE_LOAD_FBS_REQUEST';
var CORE_LOAD_FBS_SUCCESS = 'CORE_LOAD_FBS_SUCCESS';
var CORE_LOAD_FBS_FAILURE = 'CORE_LOAD_FBS_FAILURE';

var CORE_LOAD_ALL_BUILDINGS_REQUEST = 'CORE_LOAD_ALL_BUILDINGS_REQUEST';
var CORE_LOAD_ALL_BUILDINGS_SUCCESS = 'CORE_LOAD_ALL_BUILDINGS_SUCCESS';
var CORE_LOAD_ALL_BUILDINGS_FAILURE = 'CORE_LOAD_ALL_BUILDINGS_FAILURE';

var CORE_LOAD_BUILDING_REQUEST = 'CORE_LOAD_BUILDING_REQUEST';
var CORE_LOAD_BUILDING_SUCCESS = 'CORE_LOAD_BUILDING_SUCCESS';
var CORE_LOAD_BUILDING_FAILURE = 'CORE_LOAD_BUILDING_FAILURE';

var CORE_CREATE_BUILDING_REQUEST = 'CORE_CREATE_BUILDING_REQUEST';
var CORE_CREATE_BUILDING_SUCCESS = 'CORE_CREATE_BUILDING_SUCCESS';
var CORE_CREATE_BUILDING_FAILURE = 'CORE_CREATE_BUILDING_FAILURE';

var CORE_EDIT_BUILDING_REQUEST = 'CORE_EDIT_BUILDING_REQUEST';
var CORE_EDIT_BUILDING_SUCCESS = 'CORE_EDIT_BUILDING_SUCCESS';
var CORE_EDIT_BUILDING_FAILURE = 'CORE_EDIT_BUILDING_FAILURE';

var CORE_DELETE_BUILDING_REQUEST = 'CORE_DELETE_BUILDING_REQUEST';
var CORE_DELETE_BUILDING_SUCCESS = 'CORE_DELETE_BUILDING_SUCCESS';
var CORE_DELETE_BUILDING_FAILURE = 'CORE_DELETE_BUILDING_FAILURE';

var CORE_LOAD_ALL_FBS_CATEGORY_REQUEST = 'CORE_LOAD_ALL_FBS_CATEGORY_REQUEST';
var CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS = 'CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS';
var CORE_LOAD_ALL_FBS_CATEGORY_FAILURE = 'CORE_LOAD_ALL_FBS_CATEGORY_FAILURE';

var CORE_CREATE_FLOOR_REQUEST = 'CORE_CREATE_FLOOR_REQUEST';
var CORE_CREATE_FLOOR_SUCCESS = 'CORE_CREATE_FLOOR_SUCCESS';
var CORE_CREATE_FLOOR_FAILURE = 'CORE_CREATE_FLOOR_FAILURE';

var CORE_EDIT_FLOOR_REQUEST = 'CORE_EDIT_FLOOR_REQUEST';
var CORE_EDIT_FLOOR_SUCCESS = 'CORE_EDIT_FLOOR_SUCCESS';
var CORE_EDIT_FLOOR_FAILURE = 'CORE_EDIT_FLOOR_FAILURE';

var CORE_LOAD_FLOOR_REQUEST = 'CORE_LOAD_FLOOR_REQUEST';
var CORE_LOAD_FLOOR_SUCCESS = 'CORE_LOAD_FLOOR_SUCCESS';
var CORE_LOAD_FLOOR_FAILURE = 'CORE_LOAD_FLOOR_FAILURE';

var CORE_DELETE_FLOOR_REQUEST = 'CORE_DELETE_FLOOR_REQUEST';
var CORE_DELETE_FLOOR_SUCCESS = 'CORE_DELETE_FLOOR_SUCCESS';
var CORE_DELETE_FLOOR_FAILURE = 'CORE_DELETE_FLOOR_FAILURE';

var CORE_LOAD_ALL_HOLIDAYS_REQUEST = 'CORE_LOAD_ALL_HOLIDAYS_REQUEST';
var CORE_LOAD_ALL_HOLIDAYS_SUCCESS = 'CORE_LOAD_ALL_HOLIDAYS_SUCCESS';
var CORE_LOAD_ALL_HOLIDAYS_FAILURE = 'CORE_LOAD_ALL_HOLIDAYS_FAILURE';

var CORE_LOAD_HOLIDAY_REQUEST = 'CORE_LOAD_HOLIDAY_REQUEST';
var CORE_LOAD_HOLIDAY_SUCCESS = 'CORE_LOAD_HOLIDAY_SUCCESS';
var CORE_LOAD_HOLIDAY_FAILURE = 'CORE_LOAD_HOLIDAY_FAILURE';

var CORE_CREATE_HOLIDAY_REQUEST = 'CORE_CREATE_HOLIDAY_REQUEST';
var CORE_CREATE_HOLIDAY_SUCCESS = 'CORE_CREATE_HOLIDAY_SUCCESS';
var CORE_CREATE_HOLIDAY_FAILURE = 'CORE_CREATE_HOLIDAY_FAILURE';

var CORE_EDIT_HOLIDAY_REQUEST = 'CORE_EDIT_HOLIDAY_REQUEST';
var CORE_EDIT_HOLIDAY_SUCCESS = 'CORE_EDIT_HOLIDAY_SUCCESS';
var CORE_EDIT_HOLIDAY_FAILURE = 'CORE_EDIT_HOLIDAY_FAILURE';

var CORE_DELETE_HOLIDAY_REQUEST = 'CORE_DELETE_HOLIDAY_REQUEST';
var CORE_DELETE_HOLIDAY_SUCCESS = 'CORE_DELETE_HOLIDAY_SUCCESS';
var CORE_DELETE_HOLIDAY_FAILURE = 'CORE_DELETE_HOLIDAY_FAILURE';
var CORE_LOAD_DISABLE_ROOMS_REQUEST = 'CORE_LOAD_DISABLE_ROOMS_REQUEST';
var CORE_LOAD_DISABLE_ROOMS_SUCCESS = 'CORE_LOAD_DISABLE_ROOMS_SUCCESS';
var CORE_LOAD_DISABLE_ROOMS_FAILURE = 'CORE_LOAD_DISABLE_ROOMS_FAILURE';

var CORE_LOAD_DISABLE_ROOM_REQUEST = 'CORE_LOAD_DISABLE_ROOM_REQUEST';
var CORE_LOAD_DISABLE_ROOM_SUCCESS = 'CORE_LOAD_DISABLE_ROOM_SUCCESS';
var CORE_LOAD_DISABLE_ROOM_FAILURE = 'CORE_LOAD_DISABLE_ROOM_FAILURE';

var CORE_CREATE_AMENITY_REQUEST = 'CORE_CREATE_AMENITY_REQUEST';
var CORE_CREATE_AMENITY_SUCCESS = 'CORE_CREATE_AMENITY_SUCCESS';
var CORE_CREATE_AMENITY_FAILURE = 'CORE_CREATE_AMENITY_FAILURE';

var CORE_EDIT_AMENITY_REQUEST = 'CORE_EDIT_AMENITY_REQUEST';
var CORE_EDIT_AMENITY_SUCCESS = 'CORE_EDIT_AMENITY_SUCCESS';
var CORE_EDIT_AMENITY_FAILURE = 'CORE_EDIT_AMENITY_FAILURE';

var CORE_LOAD_ALL_AMENITY_REQUEST = 'CORE_LOAD_ALL_AMENITY_REQUEST';
var CORE_LOAD_ALL_AMENITY_SUCCESS = 'CORE_LOAD_ALL_AMENITY_SUCCESS';
var CORE_LOAD_ALL_AMENITY_FAILURE = 'CORE_LOAD_ALL_AMENITY_FAILURE';

var CORE_LOAD_AMENITY_REQUEST = 'CORE_LOAD_AMENITY_REQUEST';
var CORE_LOAD_AMENITY_SUCCESS = 'CORE_LOAD_AMENITY_SUCCESS';
var CORE_LOAD_AMENITY_FAILURE = 'CORE_LOAD_AMENITY_FAILURE';

var CORE_DELETE_AMENITY_REQUEST = 'CORE_DELETE_AMENITY_REQUEST';
var CORE_DELETE_AMENITY_SUCCESS = 'CORE_DELETE_AMENITY_SUCCESS';
var CORE_DELETE_AMENITY_FAILURE = 'CORE_DELETE_AMENITY_FAILURE';

var CORE_LOAD_SETTING_REQUEST = 'CORE_LOAD_SETTING_REQUEST';
var CORE_LOAD_SETTING_SUCCESS = 'CORE_LOAD_SETTING_SUCCESS';
var CORE_LOAD_SETTING_FAILURE = 'CORE_LOAD_SETTING_FAILURE';

var CORE_UPDATE_SETTING_REQUEST = 'CORE_UPDATE_SETTING_REQUEST';
var CORE_UPDATE_SETTING_SUCCESS = 'CORE_UPDATE_SETTING_SUCCESS';
var CORE_UPDATE_SETTING_FAILURE = 'CORE_UPDATE_SETTING_FAILURE';

var CORE_CREATE_TITLE_REQUEST = 'CORE_CREATE_TITLE_REQUEST';
var CORE_CREATE_TITLE_SUCCESS = 'CORE_CREATE_TITLE_SUCCESS';
var CORE_CREATE_TITLE_FAILURE = 'CORE_CREATE_TITLE_FAILURE';

var CORE_EDIT_TITLE_REQUEST = 'CORE_EDIT_TITLE_REQUEST';
var CORE_EDIT_TITLE_SUCCESS = 'CORE_EDIT_TITLE_SUCCESS';
var CORE_EDIT_TITLE_FAILURE = 'CORE_EDIT_TITLE_FAILURE';

var CORE_LOAD_ALL_TITLE_REQUEST = 'CORE_LOAD_ALL_TITLE_REQUEST';
var CORE_LOAD_ALL_TITLE_SUCCESS = 'CORE_LOAD_ALL_TITLE_SUCCESS';
var CORE_LOAD_ALL_TITLE_FAILURE = 'CORE_LOAD_ALL_TITLE_FAILURE';

var CORE_LOAD_TITLE_REQUEST = 'CORE_LOAD_TITLE_REQUEST';
var CORE_LOAD_TITLE_SUCCESS = 'CORE_LOAD_TITLE_SUCCESS';
var CORE_LOAD_TITLE_FAILURE = 'CORE_LOAD_TITLE_FAILURE';

var CORE_DELETE_TITLE_REQUEST = 'CORE_DELETE_TITLE_REQUEST';
var CORE_DELETE_TITLE_SUCCESS = 'CORE_DELETE_TITLE_SUCCESS';
var CORE_DELETE_TITLE_FAILURE = 'CORE_DELETE_TITLE_FAILURE';

var CORE_LOAD_EXECUTIVE_ROOM_REQUEST = 'CORE_LOAD_EXECUTIVE_ROOM_REQUEST';
var CORE_LOAD_EXECUTIVE_ROOM_SUCCESS = 'CORE_LOAD_EXECUTIVE_ROOM_SUCCESS';
var CORE_LOAD_EXECUTIVE_ROOM_FAILURE = 'CORE_LOAD_EXECUTIVE_ROOM_FAILURE';

var CORE_LOAD_EVENTREPORT_REQUEST = 'CORE_LOAD_EVENTREPORT_REQUEST';
var CORE_LOAD_EVENTREPORT_SUCCESS = 'CORE_LOAD_EVENTREPORT_SUCCESS';
var CORE_LOAD_EVENTREPORT_FAILURE = 'CORE_LOAD_EVENTREPORT_FAILURE';

var CORE_LOAD_ALL_ROOMFORMATS_REQUEST = 'CORE_LOAD_ALL_ROOMFORMATS_REQUEST';
var CORE_LOAD_ALL_ROOMFORMATS_SUCCESS = 'CORE_LOAD_ALL_ROOMFORMATS_SUCCESS';
var CORE_LOAD_ALL_ROOMFORMATS_FAILURE = 'CORE_LOAD_ALL_ROOMFORMATS_FAILURE';

var CORE_CREATE_ROOMFORMAT_REQUEST = 'CORE_CREATE_ROOMFORMAT_REQUEST';
var CORE_CREATE_ROOMFORMAT_SUCCESS = 'CORE_CREATE_ROOMFORMAT_SUCCESS';
var CORE_CREATE_ROOMFORMAT_FAILURE = 'CORE_CREATE_ROOMFORMAT_FAILURE';

var CORE_LOAD_ROOMFORMAT_REQUEST = 'CORE_LOAD_ROOMFORMAT_REQUEST';
var CORE_LOAD_ROOMFORMAT_SUCCESS = 'CORE_LOAD_ROOMFORMAT_SUCCESS';
var CORE_LOAD_ROOMFORMAT_FAILURE = 'CORE_LOAD_ROOMFORMAT_FAILURE';

var CORE_EDIT_ROOMFORMAT_REQUEST = 'CORE_EDIT_ROOMFORMAT_REQUEST';
var CORE_EDIT_ROOMFORMAT_SUCCESS = 'CORE_EDIT_ROOMFORMAT_SUCCESS';
var CORE_EDIT_ROOMFORMAT_FAILURE = 'CORE_EDIT_ROOMFORMAT_FAILURE';

var CORE_DELETE_ROOMFORMAT_REQUEST = 'CORE_DELETE_ROOMFORMAT_REQUEST';
var CORE_DELETE_ROOMFORMAT_SUCCESS = 'CORE_DELETE_ROOMFORMAT_SUCCESS';
var CORE_DELETE_ROOMFORMAT_FAILURE = 'CORE_DELETE_ROOMFORMAT_FAILURE';

var CORE_LOAD_USERFILTER_REQUEST = 'CORE_LOAD_USERFILTER_REQUEST';
var CORE_LOAD_USERFILTER_SUCCESS = 'CORE_LOAD_USERFILTER_SUCCESS';
var CORE_LOAD_USERFILTER_FAILURE = 'CORE_LOAD_USERFILTER_FAILURE';

var CORE_CANCEL_EVENT_REQUEST = 'CORE_CANCEL_EVENT_REQUEST';
var CORE_CANCEL_EVENT_SUCCESS = 'CORE_CANCEL_EVENT_SUCCESS';
var CORE_CANCEL_EVENT_FAILURE = 'CORE_CANCEL_EVENT_FAILURE';

var CORE_FILTER_AMENITY_REQUEST = 'CORE_FILTER_AMENITY_REQUEST';
var CORE_FILTER_AMENITY_SUCCESS = 'CORE_FILTER_AMENITY_SUCCESS';
var CORE_FILTER_AMENITY_FAILURE = 'CORE_FILTER_AMENITY_FAILURE';

var CORE_DOWN_SEQ_FBS_REQUEST = 'CORE_DOWN_SEQ_FBS_REQUEST';
var CORE_DOWN_SEQ_FBS_SUCCESS = 'CORE_DOWN_SEQ_FBS_SUCCESS';
var CORE_DOWN_SEQ_FBS_FAILURE = 'CORE_DOWN_SEQ_FBS_FAILURE';

var CORE_UP_SEQ_FBS_REQUEST = 'CORE_UP_SEQ_FBS_REQUEST';
var CORE_UP_SEQ_FBS_SUCCESS = 'CORE_UP_SEQ_FBS_SUCCESS';
var CORE_UP_SEQ_FBS_FAILURE = 'CORE_UP_SEQ_FBS_FAILURE';

var CORE_DOWN_SEQ_AMENITY_REQUEST = 'CORE_DOWN_SEQ_AMENITY_REQUEST';
var CORE_DOWN_SEQ_AMENITY_SUCCESS = 'CORE_DOWN_SEQ_AMENITY_SUCCESS';
var CORE_DOWN_SEQ_AMENITY_FAILURE = 'CORE_DOWN_SEQ_AMENITY_FAILURE';

var CORE_UP_SEQ_AMENITY_REQUEST = 'CORE_UP_SEQ_AMENITY_REQUEST';
var CORE_UP_SEQ_AMENITY_SUCCESS = 'CORE_UP_SEQ_AMENITY_SUCCESS';
var CORE_UP_SEQ_AMENITY_FAILURE = 'CORE_UP_SEQ_AMENITY_FAILURE';

var CORE_DOWN_SEQ_TITLE_REQUEST = 'CORE_DOWN_SEQ_TITLE_REQUEST';
var CORE_DOWN_SEQ_TITLE_SUCCESS = 'CORE_DOWN_SEQ_TITLE_SUCCESS';
var CORE_DOWN_SEQ_TITLE_FAILURE = 'CORE_DOWN_SEQ_TITLE_FAILURE';

var CORE_UP_SEQ_TITLE_REQUEST = 'CORE_UP_SEQ_TITLE_REQUEST';
var CORE_UP_SEQ_TITLE_SUCCESS = 'CORE_UP_SEQ_TITLE_SUCCESS';
var CORE_UP_SEQ_TITLE_FAILURE = 'CORE_UP_SEQ_TITLE_FAILURE';

var CORE_FILTER_ROOM_REQUEST = 'CORE_FILTER_ROOM_REQUEST';
var CORE_FILTER_ROOM_SUCCESS = 'CORE_FILTER_ROOM_SUCCESS';
var CORE_FILTER_ROOM_FAILURE = 'CORE_FILTER_ROOM_FAILURE';

var CORE_FILTER_ROOMFORMAT_REQUEST = 'CORE_FILTER_ROOMFORMAT_REQUEST';
var CORE_FILTER_ROOMFORMAT_SUCCESS = 'CORE_FILTER_ROOMFORMAT_SUCCESS';
var CORE_FILTER_ROOMFORMAT_FAILURE = 'CORE_FILTER_ROOMFORMAT_FAILURE';

var CORE_FILTER_FLOOR_REQUEST = 'CORE_FILTER_FLOOR_REQUEST';
var CORE_FILTER_FLOOR_SUCCESS = 'CORE_FILTER_FLOOR_SUCCESS';
var CORE_FILTER_FLOOR_FAILURE = 'CORE_FILTER_FLOOR_FAILURE';

var CORE_FILTER_FBS_REQUEST = 'CORE_FILTER_FBS_REQUEST';
var CORE_FILTER_FBS_SUCCESS = 'CORE_FILTER_FBS_SUCCESS';
var CORE_FILTER_FBS_FAILURE = 'CORE_FILTER_FBS_FAILURE';

var CORE_FILTER_BUILDING_REQUEST = 'CORE_FILTER_BUILDING_REQUEST';
var CORE_FILTER_BUILDING_SUCCESS = 'CORE_FILTER_BUILDING_SUCCESS';
var CORE_FILTER_BUILDING_FAILURE = 'CORE_FILTER_BUILDING_FAILURE';

var CORE_LOAD_ADMINREPORT_REQUEST = 'CORE_LOAD_ADMINREPORT_REQUEST';
var CORE_LOAD_ADMINREPORT_SUCCESS = 'CORE_LOAD_ADMINREPORT_SUCCESS';
var CORE_LOAD_ADMINREPORT_FAILURE = 'CORE_LOAD_ADMINREPORT_FAILURE';

var CORE_SEARCH_EVENTS_REQUEST = 'CORE_SEARCH_EVENTS_REQUEST';
var CORE_SEARCH_EVENTS_SUCCESS = 'CORE_SEARCH_EVENTS_SUCCESS';
var CORE_SEARCH_EVENTS_FAILURE = 'CORE_SEARCH_EVENTS_FAILURE';

var CORE_LOAD_PRIVATE_ROOM_REQUEST = 'CORE_LOAD_PRIVATE_ROOM_REQUEST';
var CORE_LOAD_PRIVATE_ROOM_SUCCESS = 'CORE_LOAD_PRIVATE_ROOM_SUCCESS';
var CORE_LOAD_PRIVATE_ROOM_FAILURE = 'CORE_LOAD_PRIVATE_ROOM_FAILURE';

var CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST = 'CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST';
var CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS = 'CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS';
var CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE = 'CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE';

var CORE_REOPEN_EVENT_REQUEST = 'CORE_REOPEN_EVENT_REQUEST';
var CORE_REOPEN_EVENT_SUCCESS = 'CORE_REOPEN_EVENT_SUCCESS';
var CORE_REOPEN_EVENT_FAILURE = 'CORE_REOPEN_EVENT_FAILURE';

var CORE_REQUEST_CHANGE_PASSWORD_REQUEST = 'CORE_REQUEST_CHANGE_PASSWORD_REQUEST';
var CORE_REQUEST_CHANGE_PASSWORD_SUCCESS = 'CORE_REQUEST_CHANGE_PASSWORD_SUCCESS';
var CORE_REQUEST_CHANGE_PASSWORD_FAILURE = 'CORE_REQUEST_CHANGE_PASSWORD_FAILURE';

var CORE_IMPORT_USER_FILE_REQUEST = 'CORE_IMPORT_USER_FILE_REQUEST';
var CORE_IMPORT_USER_FILE_SUCCESS = 'CORE_IMPORT_USER_FILE_SUCCESS';
var CORE_IMPORT_USER_FILE_FAILURE = 'CORE_IMPORT_USER_FILE_FAILURE';

var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST';
var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS';
var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE';

var CORE_LOAD_ALL_DEPARTMENT_REQUEST = 'CORE_LOAD_ALL_DEPARTMENT_REQUEST';
var CORE_LOAD_ALL_DEPARTMENT_SUCCESS = 'CORE_LOAD_ALL_DEPARTMENT_SUCCESS';
var CORE_LOAD_ALL_DEPARTMENT_FAILURE = 'CORE_LOAD_ALL_DEPARTMENT_FAILURE';

var CORE_LOAD_SEARCH_DEPARTMENT_REQUEST = 'CORE_LOAD_SEARCH_DEPARTMENT_REQUEST';
var CORE_LOAD_SEARCH_DEPARTMENT_SUCCESS = 'CORE_LOAD_SEARCH_DEPARTMENT_SUCCESS';
var CORE_LOAD_SEARCH_DEPARTMENT_FAILURE = 'CORE_LOAD_SEARCH_DEPARTMENT_FAILURE';

var CORE_LOAD_DEPARTMENT_REQUEST = 'CORE_LOAD_DEPARTMENT_REQUEST';
var CORE_LOAD_DEPARTMENT_SUCCESS = 'CORE_LOAD_DEPARTMENT_SUCCESS';
var CORE_LOAD_DEPARTMENT_FAILURE = 'CORE_LOAD_DEPARTMENT_FAILURE';

var CORE_DELETE_DEPARTMENT_REQUEST = 'CORE_DELETE_DEPARTMENT_REQUEST';
var CORE_DELETE_DEPARTMENT_SUCCESS = 'CORE_DELETE_DEPARTMENT_SUCCESS';
var CORE_DELETE_DEPARTMENT_FAILURE = 'CORE_DELETE_DEPARTMENT_FAILURE';

var CORE_LOAD_ALL_ROOMTYPE_REQUEST = 'CORE_LOAD_ALL_ROOMTYPE_REQUEST';
var CORE_LOAD_ALL_ROOMTYPE_SUCCESS = 'CORE_LOAD_ALL_ROOMTYPE_SUCCESS';
var CORE_LOAD_ALL_ROOMTYPE_FAILURE = 'CORE_LOAD_ALL_ROOMTYPE_FAILURE';

var CORE_LOAD_SEARCH_ROOMTYPE_REQUEST = 'CORE_LOAD_SEARCH_ROOMTYPE_REQUEST';
var CORE_LOAD_SEARCH_ROOMTYPE_SUCCESS = 'CORE_LOAD_SEARCH_ROOMTYPE_SUCCESS';
var CORE_LOAD_SEARCH_ROOMTYPE_FAILURE = 'CORE_LOAD_SEARCH_ROOMTYPE_FAILURE';

var CORE_LOAD_ROOMTYPE_REQUEST = 'CORE_LOAD_ROOMTYPE_REQUEST';
var CORE_LOAD_ROOMTYPE_SUCCESS = 'CORE_LOAD_ROOMTYPE_SUCCESS';
var CORE_LOAD_ROOMTYPE_FAILURE = 'CORE_LOAD_ROOMTYPE_FAILURE';

var CORE_DELETE_ROOMTYPE_REQUEST = 'CORE_DELETE_ROOMTYPE_REQUEST';
var CORE_DELETE_ROOMTYPE_SUCCESS = 'CORE_DELETE_ROOMTYPE_SUCCESS';
var CORE_DELETE_ROOMTYPE_FAILURE = 'CORE_DELETE_ROOMTYPE_FAILURE';

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 403, 404, 422, 500];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });

        if (resStatusError.includes(res.status)) {
            if (res.status === 422) {
                return res.json().then(function (json) {
                    var message = "";

                    for (var key in json) {
                        if (json.hasOwnProperty(key)) {
                            var element = json[key];
                            for (var k in element) {
                                if (element.hasOwnProperty(k)) {
                                    var ele = element[k];
                                    if (ele.param) message += ele.param + " ";
                                    message += "" + ele.msg;
                                    message += "\n";
                                }
                            }
                        }
                    }

                    return reject({
                        statusText: res.statusText, data: {
                            code: res.status.toString(),
                            message: message
                        }
                    });
                });
            } else {
                return res.json().then(function (data) {
                    return reject({ statusText: data.code, code: data.code, message: data.message });
                });
            }
        }

        if ((typeof type === "undefined" ? "undefined" : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
    // return new Promise((resolve, reject) => {
    //     if(!res) return resolve({ type })

    //     if(resStatusError.includes(res.status)){
    //         res
    //         .json()
    //         .then(json => {
    //             // return json.value
    //             return reject({ statusText: res.statusText, ...json })
    //         })

    //     }

    //     if(typeof type === 'object'){
    //         if(type.payload){
    //             const payload = type.payload(action, state, res)
    //             if(typeof payload.then === 'function'){ //promise
    //                 return payload.then(data => resolve( { type: type.type, payload: data}))          
    //             }else{
    //                 return resolve({ type: type.type, payload})
    //             }
    //         }

    //         return resolve({type: type.type})
    //     }

    //     res.json().then(payload => resolve({ type, payload }))
    // })
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();

            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(674);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(87);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];
            var currentTime = moment_timezone_default()().format(lib["p" /* timeFormat */]);

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            if (typeof entry !== "undefined") {
                if (typeof entry.tokentype !== "undefined" && entry.tokentype) {
                    var _getServiceToken = Object(lib["j" /* getServiceToken */])(),
                        service_token = _getServiceToken.service_token,
                        service_expires_on = _getServiceToken.service_expires_on;

                    if (!service_token) return next(action);

                    var serviceDuration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(service_expires_on).diff(currentTime));
                    var serviceMinutes = serviceDuration.asMinutes();

                    var bsrs_token = Object(lib["h" /* getBSRSToken */])();
                    if (serviceMinutes < 10) {
                        fetch(lib["a" /* CORE_API_ENDPOINT */] + '/o365/service_token', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + bsrs_token
                            }
                        }).then(function (res) {
                            return res.json();
                        }).then(function (json) {
                            return Object(lib["n" /* setServiceToken */])(json);
                        }).then(function () {
                            return next(action);
                        });
                    } else {
                        next(action);
                    }
                }
            }

            var isO365 = entry.types[0].startsWith("O365");

            if (isO365) {
                var token = Object(lib["f" /* getAccessToken */])();

                if (!token) return next(action);

                var _getAllToken = Object(lib["g" /* getAllToken */])(),
                    expires_on = _getAllToken.expires_on,
                    refresh_token = _getAllToken.refresh_token;

                var _currentTime = moment_timezone_default()().format(lib["p" /* timeFormat */]);
                var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expires_on).diff(_currentTime));
                var minutes = duration.asMinutes();

                if (minutes < 10) {
                    fetch(lib["a" /* CORE_API_ENDPOINT */] + '/o365/refresh_token', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ refresh_token: refresh_token })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (json) {
                        return Object(lib["o" /* setToken */])(json);
                    }).then(function () {
                        return next(action);
                    });
                } else {
                    next(action);
                }
            } else {
                next(action);
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
  return function (next) {
    return function (action) {
      var entry = action[CALL_API];

      if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

      var token = void 0;
      var entryType = entry.types[0];

      if (entryType.startsWith("CORE")) {
        var _getBSRSToken = Object(lib["h" /* getBSRSToken */])(),
            bsrsToken = _getBSRSToken.bsrsToken;

        token = bsrsToken;
      }
      // else if(entry.types[0].startsWith("O365")){ 
      //   if(typeof(entry.tokentype) !== undefined && entry.tokentype === 'service' ){ 
      //     const { service_token } = getServiceToken()
      //     token = service_token
      //   }
      //   else token = getAccessToken()
      // }

      if (!token) return next(action);

      entry.headers = _extends({}, entry.headers, { 'Authorization': 'Bearer ' + token });

      next(action);
    };
  };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Loading...'
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PREFIX; });

// export const CORE_API_ENDPOINT = `http://localhost:2701`
var CORE_API_ENDPOINT = '/api';
// export const CORE_API_ENDPOINT = `https://dtacuat-back.rmbainisys.com/api`
// export const PREFIX = `/backend`
var PREFIX = '';

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authorizeBSRS;
/* harmony export (immutable) */ __webpack_exports__["c"] = requestChangePassword;
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Lib__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Middlewares__ = __webpack_require__(326);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function authorizeBSRS(_ref, history) {
    var email = _ref.email,
        password = _ref.password;

    var body = { email: email, password: password };
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/adminverify/',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["b" /* BSRS_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* BSRS_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var _json$value = json.value,
                        token = _json$value.token,
                        data = _json$value.data,
                        result_per_page = _json$value.result_per_page;
                    var role = data.role,
                        userId = data.userId,
                        isFirstChangePassword = data.isFirstChangePassword;

                    if (role !== 'admin' && role !== 'superadmin') window.location.replace(__WEBPACK_IMPORTED_MODULE_1_Lib__["c" /* PREFIX */] + '/withoutpermission');else {
                        var loginData = { token: token, role: role, userId: userId, result_per_page: result_per_page, isFirstChangePassword: isFirstChangePassword };
                        Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["m" /* setBSRSToken */])(loginData);
                    }
                    return { token: token, role: role, data: data };
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* BSRS_LOGIN_FAILURE */]]
    });
}

function requestChangePassword(userId) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/resetpassword/' + userId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_238" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_239" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_237" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE */]]
    });
}

function logout() {
    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["d" /* clearBSRSToken */])();
    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["e" /* clearToken */])();

    return {
        type: __WEBPACK_IMPORTED_MODULE_0__types__["_258" /* LOGOUT */]
    };
}

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(655);


/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(663);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var es = __webpack_require__(135);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var react_redux_es = __webpack_require__(36);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(670);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(671);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(163);

// EXTERNAL MODULE: ./src/features/auth/actions.js
var actions = __webpack_require__(650);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(166);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(325);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(87);

// CONCATENATED MODULE: ./src/features/ui/components/Header.js








// const trigger = (
//     <span><Icon name='user' /></span>
// )

var Header_NoAuthHeader = function NoAuthHeader() {
    return react_default.a.createElement('div', null);
};

var Header_AuthHeader = function AuthHeader(_ref) {
    var logout = _ref.logout;
    return react_default.a.createElement(
        dist_es["c" /* Container */],
        null,
        react_default.a.createElement(
            dist_es["p" /* Menu */],
            { secondary: true },
            react_default.a.createElement(
                dist_es["p" /* Menu */].Item,
                { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/' },
                'Home'
            ),
            react_default.a.createElement(
                dist_es["p" /* Menu */].Item,
                { style: { minWidth: '140px' } },
                react_default.a.createElement(
                    dist_es["f" /* Dropdown */],
                    { item: true, text: 'Monitor', style: { width: '100%' } },
                    react_default.a.createElement(
                        dist_es["f" /* Dropdown */].Menu,
                        null,
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/eventreport' },
                            '  Events'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/adminreport' },
                            '  Feedback'
                        )
                    )
                )
            ),
            react_default.a.createElement(
                dist_es["p" /* Menu */].Item,
                { style: { minWidth: '150px' } },
                react_default.a.createElement(
                    dist_es["f" /* Dropdown */],
                    { item: true, text: 'Master Data', style: { width: '100%' } },
                    react_default.a.createElement(
                        dist_es["f" /* Dropdown */].Menu,
                        null,
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/user/local' },
                            'Users'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/departments' },
                            'Departments'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */],
                            { item: true, text: 'Locations' },
                            react_default.a.createElement(
                                dist_es["f" /* Dropdown */].Menu,
                                null,
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/room' },
                                    'Room'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/roomtype' },
                                    'Room Type'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/roomformat' },
                                    'Room Format'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/floors' },
                                    'Floors'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/building' },
                                    'Buildings'
                                )
                            )
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */],
                            { item: true, text: 'Orders' },
                            react_default.a.createElement(
                                dist_es["f" /* Dropdown */].Menu,
                                null,
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/fbsCategory' },
                                    'Food & Drinks Category'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/fbs' },
                                    'Food & Drinks'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/amenity' },
                                    'Facilities'
                                )
                            )
                        )
                    )
                )
            ),
            react_default.a.createElement(
                dist_es["p" /* Menu */].Item,
                { style: { minWidth: '150px' } },
                react_default.a.createElement(
                    dist_es["f" /* Dropdown */],
                    { item: true, text: 'Report', style: { width: '100%' } },
                    react_default.a.createElement(
                        dist_es["f" /* Dropdown */].Menu,
                        null,
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/roombyname' },
                            '  Room Usage By Name'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/roombytype' },
                            '  Room Usage By Type'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/reportbyuser' },
                            '  Report By user '
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */],
                            { item: true, text: 'Report Order' },
                            react_default.a.createElement(
                                dist_es["f" /* Dropdown */].Menu,
                                null,
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/fbssummary' },
                                    'Food & Drinks Summary'
                                ),
                                react_default.a.createElement(
                                    dist_es["f" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/amenitiessummary' },
                                    'Facilities Summary'
                                )
                            )
                        )
                    )
                )
            ),
            react_default.a.createElement(
                dist_es["p" /* Menu */].Item,
                { style: { minWidth: '200px' } },
                react_default.a.createElement(
                    dist_es["f" /* Dropdown */],
                    { item: true, text: 'Setting', style: { width: '100%' } },
                    react_default.a.createElement(
                        dist_es["f" /* Dropdown */].Menu,
                        null,
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/setting' },
                            '  Global'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/setting/message' },
                            '  Message'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/term' },
                            '  Term & Conditions'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/term/trainingroom' },
                            '  Term & Condition for Training Room'
                        )
                    )
                )
            ),
            react_default.a.createElement(
                dist_es["p" /* Menu */].Item,
                { position: 'right' },
                react_default.a.createElement(
                    dist_es["f" /* Dropdown */],
                    { item: true, text: 'Profile' },
                    react_default.a.createElement(
                        dist_es["f" /* Dropdown */].Menu,
                        null,
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { as: es["b" /* Link */], to: lib["c" /* PREFIX */] + '/user/info' },
                            'User Infomation'
                        ),
                        react_default.a.createElement(
                            dist_es["f" /* Dropdown */].Item,
                            { onClick: logout },
                            'Log Out'
                        )
                    )
                )
            )
        )
    );
};

var Header_Header = function Header(_ref2) {
    var isLoggedIn = _ref2.isLoggedIn,
        logout = _ref2.logout;
    return react_default.a.createElement(
        'div',
        null,
        isLoggedIn ? react_default.a.createElement(Header_AuthHeader, { logout: logout }) : react_default.a.createElement(Header_NoAuthHeader, null)
    );
};

/* harmony default export */ var components_Header = (Object(Recompose["b" /* compose */])(es["f" /* withRouter */], Object(react_redux_es["connect"])(function (state) {
    return { isLoggedIn: Object(selectors["b" /* getIsLoggedIn */])(state) };
}, function (dispatch, props) {
    return {
        logout: function logout() {
            dispatch(Object(actions["b" /* logout */])());
        }
    };
}))(Header_Header));
// EXTERNAL MODULE: ./src/features/ui/components/Loadable.js
var Loadable = __webpack_require__(648);

// CONCATENATED MODULE: ./src/features/ui/components/Routes.js




// import ContentAdd from 'material-ui/SvgIcon';

var AsyncHome = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1615));
    }
});

var AsyncNotFound = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1616));
    }
});

var AsyncLoginBSRS = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1617));
    }
});

var AsyncTest = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1619));
    }
});

// const AsyncUsers = Loadable({
//     loader: () => import('../../users/components/Users')
// })

// const AsyncCreateSyncUser = Loadable({
//     loader: () => import('../../users/components/CreateUser')
// })

// const AsyncCreateSyncUserWithoutEmail = Loadable({
//     loader: () => import('../../users/components/CreateUserWithoutEmail')
// })
var AsyncChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1620));
    }
});

var AsyncForgotPassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1621));
    }
});

var AsyncFirstChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1622));
    }
});

var AsyncRoomLocal = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1623));
    }
});

var AsyncDisableRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1624));
    }
});

var AsyncCreateDisableRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1625));
    }
});

var AsyncEditDisableRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1626));
    }
});

var AsyncCreateRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1627));
    }
});

var AsyncEditRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1628));
    }
});

// const AsyncLocalUsers = Loadable({
//     loader: () => import('../../users/components/UsersLocal')
// })

var AsyncLocalEditUsers = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1629));
    }
});

var AsyncQRcode = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1630));
    }
});

var AsyncWithOutPermission = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1631));
    }
});

var AsyncImage = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1619));
    }
});

var AsyncUserList = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1632));
    }
});

// const AsyncFBS = Loadable({
//     loader: () => import('../../fbs/components/Fbs')
// })

var AsyncFBSlist = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1633));
    }
});

var AsyncFBSEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1634));
    }
});

var AsyncFBScreate = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1635));
    }
});

var AsyncBuilding = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1636));
    }
});

var AsyncCreateBuilding = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1637));
    }
});

var AsyncEditBuilding = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1638));
    }
});

var AsyncRoomFormat = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1639));
    }
});

var AsyncCreateRoomFormat = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1640));
    }
});

var AsyncEditRoomFormat = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1641));
    }
});

var AsyncFbsCategory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1642));
    }
});
var AsyncCreateFBSCategory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1643));
    }
});
var AsyncEditFBSCategory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1644));
    }
});

var AsyncFloors = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1645));
    }
});

var AsyncCreateFloor = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1646));
    }
});

var AsyncEditFloor = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1647));
    }
});

var AsyncHolidays = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1648));
    }
});

var AsyncCreateHoliday = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1649));
    }
});

var AsyncEditHoliday = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1650));
    }
});

var AsyncAmenitylist = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1651));
    }
});

var AsyncAmenityEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1652));
    }
});

var AsyncAmenitycreate = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1653));
    }
});

var AsyncSetting = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1654));
    }
});

var AsyncSettingEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1655));
    }
});

var AsyncSettingEmail = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1656));
    }
});

var AsyncTitle = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1657));
    }
});

var AsyncCreateTitle = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1658));
    }
});

var AsyncEditTitle = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1659));
    }
});

var AsyncCreateLocalUser = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1660));
    }
});

var AsyncUserInfo = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1661));
    }
});

var AsyncEventReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1662));
    }
});

var AsyncAdminReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1663));
    }
});
var AsyncRoomUsageByNameReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1664));
    }
});

var AsyncRoomUsageByTypeReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1665));
    }
});

var AsyncUsageByUserReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1666));
    }
});

var AsyncFBSSummaryReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1667));
    }
});

var AsyncAmenitiesSummaryReport = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1668));
    }
});

var AsyncTermForm = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1669));
    }
});

var AsyncTermForTrainingRoomForm = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1670));
    }
});

var AsyncTerm = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1671));
    }
});

var TermForTrainingRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1672));
    }
});

var AsyncUploadUsers = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1673));
    }
});

var AsyncUploadRooms = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1674));
    }
});

var AsyncUploadEvents = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1675));
    }
});

//Department
var AsyncDepartments = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1676));
    }
});
var AsyncCreateDepartment = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1677));
    }
});
var AsyncEditDepartment = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1678));
    }
});

//Room Type
var AsyncRoomTypes = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1679));
    }
});
var AsyncCreateRoomType = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1680));
    }
});
var AsyncEditRoomType = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1681));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["e" /* Switch */],
        null,
        react_default.a.createElement(es["d" /* Route */], { exact: true, path: lib["c" /* PREFIX */] + '/', component: AsyncHome }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/login', component: AsyncLoginBSRS }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/img', component: AsyncImage }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/withoutpermission', component: AsyncWithOutPermission }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/department/edit/:id', component: AsyncEditDepartment }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/department/create', component: AsyncCreateDepartment }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/departments', component: AsyncDepartments }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roomtype/edit/:id', component: AsyncEditRoomType }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roomtype/create', component: AsyncCreateRoomType }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roomtype', component: AsyncRoomTypes }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/user/local/create', component: AsyncCreateLocalUser }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/user/local/edit/:id', component: AsyncLocalEditUsers }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/user/changePassword/:id', component: AsyncChangePassword }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/user/firstChangePassword/:id', component: AsyncFirstChangePassword }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/user/local', component: AsyncUserList }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/user/info', component: AsyncUserInfo }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/reset/:id', component: AsyncForgotPassword }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room/qrcode/:id', component: AsyncQRcode }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room/edit/:id', component: AsyncEditRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room/create', component: AsyncCreateRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room/disable/edit/:id', component: AsyncEditDisableRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room/disable/create', component: AsyncCreateDisableRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room/disable', component: AsyncDisableRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/room', component: AsyncRoomLocal }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/qrcode', component: AsyncQRcode }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbs/create', component: AsyncFBScreate }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbs/edit/:id', component: AsyncFBSEdit }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbs', component: AsyncFBSlist }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/title/create', component: AsyncCreateTitle }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/title/edit/:id', component: AsyncEditTitle }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/title', component: AsyncTitle }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/setting/edit/:id', component: AsyncSettingEdit }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/setting/message', component: AsyncSettingEmail }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/setting', component: AsyncSetting }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/amenity/create', component: AsyncAmenitycreate }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/amenity/edit/:id', component: AsyncAmenityEdit }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/amenity', component: AsyncAmenitylist }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbsCategory/edit/:id', component: AsyncEditFBSCategory }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbsCategory/create', component: AsyncCreateFBSCategory }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbsCategory', component: AsyncFbsCategory }),
        react_default.a.createElement(es["d" /* Route */], { path: '/test', component: AsyncTest }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/floors', component: AsyncFloors }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/floor/edit/:id', component: AsyncEditFloor }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/floor/create', component: AsyncCreateFloor }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/building/create', component: AsyncCreateBuilding }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/building/edit/:id', component: AsyncEditBuilding }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/building', component: AsyncBuilding }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/holidays', component: AsyncHolidays }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/holiday/create', component: AsyncCreateHoliday }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/holiday/edit/:id', component: AsyncEditHoliday }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/fbssummary', component: AsyncFBSSummaryReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/amenitiessummary', component: AsyncAmenitiesSummaryReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/eventreport', component: AsyncEventReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/adminreport', component: AsyncAdminReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roombyname', component: AsyncRoomUsageByNameReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roombytype', component: AsyncRoomUsageByTypeReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/reportbyuser', component: AsyncUsageByUserReport }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roomformat/create', component: AsyncCreateRoomFormat }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roomformat/edit/:id', component: AsyncEditRoomFormat }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/roomformat', component: AsyncRoomFormat }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/editterm/trainingroom/:id', component: AsyncTermForTrainingRoomForm }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/editterm/:id', component: AsyncTermForm }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/term/trainingroom', component: TermForTrainingRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/term', component: AsyncTerm }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/uploaduser', component: AsyncUploadUsers }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/uploadrooms', component: AsyncUploadRooms }),
        react_default.a.createElement(es["d" /* Route */], { path: lib["c" /* PREFIX */] + '/uploadevents', component: AsyncUploadEvents }),
        react_default.a.createElement(es["d" /* Route */], { component: AsyncNotFound })
    );
});
// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var babel_polyfill_lib = __webpack_require__(1068);
var lib_default = /*#__PURE__*/__webpack_require__.n(babel_polyfill_lib);

// CONCATENATED MODULE: ./src/features/ui/components/App.js



// import Footer from './Footer'



/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_Header, null),
        react_default.a.createElement(
            dist_es["c" /* Container */],
            { style: { minHeight: '219px' } },
            react_default.a.createElement(Routes, null)
        )
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js






var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
    return react_default.a.createElement(
        react_redux_es["Provider"],
        { store: store },
        react_default.a.createElement(
            es["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(App, null)
        )
    );
});

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(672);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(137);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(673);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(326);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(652);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(802);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(31);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var src_lib = __webpack_require__(87);

// CONCATENATED MODULE: ./src/features/auth/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var allToken = Object(src_lib["g" /* getAllToken */])();

var _getBSRSToken = Object(src_lib["h" /* getBSRSToken */])(),
    bsrsToken = _getBSRSToken.bsrsToken;

var serviceToken = Object(src_lib["j" /* getServiceToken */])();

var reducer_initialState = {
  token: allToken,
  bsrsToken: bsrsToken,
  user: Object(src_lib["k" /* getUserInfo */])(allToken.access_token),
  serviceToken: serviceToken
};

/* harmony default export */ var reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case types["_259" /* O365_REGISTER_SUCCESS */]:
      {
        return _extends({}, state, {
          token: _extends({}, action.payload.token),
          user: Object(src_lib["k" /* getUserInfo */])(action.payload.token.access_token)
        });
      }
    case types["c" /* BSRS_LOGIN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken,
          isAdmin: action.payload.role,
          user: action.payload.data
        });
      }
    case types["d" /* BSRS_SERVICE_TOKEN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken,
          serviceToken: action.payload.serviceToken
        });
      }
    case types["_258" /* LOGOUT */]:
      return _extends({}, state, {
        bsrsToken: undefined
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/features/ui/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var ui_reducer_initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
};

/* harmony default export */ var ui_reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["Y" /* CORE_DELETE_BUILDING_REQUEST */]:
        case types["_10" /* CORE_DELETE_FLOOR_REQUEST */]:
        case types["_169" /* CORE_LOAD_ORDERS_REQUEST */]:
        case types["_91" /* CORE_FIND_ROOM_REQUEST */]:
        case types["_223" /* CORE_LOAD_USER_REQUEST */]:
        case types["_247" /* CORE_UPDATE_USER_REQUEST */]:
        case types["_31" /* CORE_DELETE_USER_REQUEST */]:
        case types["_220" /* CORE_LOAD_USERS_REQUEST */]:
        case types["_100" /* CORE_LOAD_ALLROOM_REQUEST */]:
        case types["_241" /* CORE_UPDATE_ROOM_REQUEST */]:
        case types["_157" /* CORE_LOAD_FBS_REQUEST */]:
        case types["x" /* CORE_CREATE_FBS_REQUEST */]:
        case types["_121" /* CORE_LOAD_ALL_FLOOR_REQUEST */]:
        case types["J" /* CORE_CREATE_ROOM_REQUEST */]:
        case types["_103" /* CORE_LOAD_ALL_AMENITIES_REQUEST */]:
        case types["A" /* CORE_CREATE_FLOOR_REQUEST */]:
        case types["_166" /* CORE_LOAD_LOCAL_USERS_REQUEST */]:
        case types["b" /* BSRS_LOGIN_REQUEST */]:
        case types["i" /* CORE_CHANGE_PASSWORD_REQUEST */]:
        case types["S" /* CORE_CREATE_USER_REQUEST */]:
        case types["_25" /* CORE_DELETE_ROOM_REQUEST */]:
        case types["_67" /* CORE_EDIT_SYNC_REQUEST */]:
        case types["_232" /* CORE_RESET_PASSWORD_REQUEST */]:
        case types["_196" /* CORE_LOAD_ROOM_REQUEST */]:
        case types["_148" /* CORE_LOAD_DISABLE_ROOM_REQUEST */]:
        case types["_154" /* CORE_LOAD_EXECUTIVE_ROOM_REQUEST */]:
        case types["_181" /* CORE_LOAD_ROLE_REQUEST */]:
        case types["_115" /* CORE_LOAD_ALL_FBS_CATEGORY_REQUEST */]:
        case types["_109" /* CORE_LOAD_ALL_BUILDINGS_REQUEST */]:
        case types["_151" /* CORE_LOAD_EVENTREPORT_REQUEST */]:
        case types["f" /* CORE_CANCEL_EVENT_REQUEST */]:
        case types["_187" /* CORE_LOAD_ROOMS_REQUEST */]:
        case types["_118" /* CORE_LOAD_ALL_FBS_REQUEST */]:
        case types["_133" /* CORE_LOAD_ALL_TITLE_REQUEST */]:
        case types["_127" /* CORE_LOAD_ALL_ROOMFORMATS_REQUEST */]:
        case types["_130" /* CORE_LOAD_ALL_ROOMTYPE_REQUEST */]:
        case types["_205" /* CORE_LOAD_SETTING_REQUEST */]:
        case types["_244" /* CORE_UPDATE_SETTING_REQUEST */]:
        case types["_235" /* CORE_SEARCH_EVENTS_REQUEST */]:
        case types["_172" /* CORE_LOAD_PRIVATE_ROOM_REQUEST */]:
        case types["_194" /* CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST */]:
        case types["o" /* CORE_CREATE_AMENITY_REQUEST */]:
        case types["r" /* CORE_CREATE_BUILDING_REQUEST */]:
        case types["_46" /* CORE_EDIT_BUILDING_REQUEST */]:
        case types["_145" /* CORE_LOAD_DISABLE_ROOMS_REQUEST */]:
        case types["_94" /* CORE_IMPORT_USER_FILE_REQUEST */]:
        case types["_226" /* CORE_REOPEN_EVENT_REQUEST */]:
        case types["_238" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */]:
        case types["_106" /* CORE_LOAD_ALL_AMENITY_REQUEST */]:
        case types["_112" /* CORE_LOAD_ALL_DEPARTMENT_REQUEST */]:
        case types["_142" /* CORE_LOAD_DEPARTMENT_REQUEST */]:
        case types["_1" /* CORE_DELETE_DEPARTMENT_REQUEST */]:
        case types["_190" /* CORE_LOAD_ROOMTYPE_REQUEST */]:
        case types["_22" /* CORE_DELETE_ROOMTYPE_REQUEST */]:
            return reducer__extends({}, state, {
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["Z" /* CORE_DELETE_BUILDING_SUCCESS */]:
        case types["_11" /* CORE_DELETE_FLOOR_SUCCESS */]:
        case types["_170" /* CORE_LOAD_ORDERS_SUCCESS */]:
        case types["_92" /* CORE_FIND_ROOM_SUCCESS */]:
        case types["_26" /* CORE_DELETE_ROOM_SUCCESS */]:
        case types["_224" /* CORE_LOAD_USER_SUCCESS */]:
        case types["_248" /* CORE_UPDATE_USER_SUCCESS */]:
        case types["_32" /* CORE_DELETE_USER_SUCCESS */]:
        case types["_221" /* CORE_LOAD_USERS_SUCCESS */]:
        case types["_101" /* CORE_LOAD_ALLROOM_SUCCESS */]:
        case types["_242" /* CORE_UPDATE_ROOM_SUCCESS */]:
        case types["_158" /* CORE_LOAD_FBS_SUCCESS */]:
        case types["y" /* CORE_CREATE_FBS_SUCCESS */]:
        case types["_122" /* CORE_LOAD_ALL_FLOOR_SUCCESS */]:
        case types["K" /* CORE_CREATE_ROOM_SUCCESS */]:
        case types["_104" /* CORE_LOAD_ALL_AMENITIES_SUCCESS */]:
        case types["B" /* CORE_CREATE_FLOOR_SUCCESS */]:
        case types["_167" /* CORE_LOAD_LOCAL_USERS_SUCCESS */]:
        case types["c" /* BSRS_LOGIN_SUCCESS */]:
        case types["j" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
        case types["T" /* CORE_CREATE_USER_SUCCESS */]:
        case types["_68" /* CORE_EDIT_SYNC_SUCCESS */]:
        case types["_233" /* CORE_RESET_PASSWORD_SUCCESS */]:
        case types["_182" /* CORE_LOAD_ROLE_SUCCESS */]:
        case types["_155" /* CORE_LOAD_EXECUTIVE_ROOM_SUCCESS */]:
        case types["_149" /* CORE_LOAD_DISABLE_ROOM_SUCCESS */]:
        case types["_197" /* CORE_LOAD_ROOM_SUCCESS */]:
        case types["_116" /* CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS */]:
        case types["_110" /* CORE_LOAD_ALL_BUILDINGS_SUCCESS */]:
        case types["_152" /* CORE_LOAD_EVENTREPORT_SUCCESS */]:
        case types["g" /* CORE_CANCEL_EVENT_SUCCESS */]:
        case types["_188" /* CORE_LOAD_ROOMS_SUCCESS */]:
        case types["_119" /* CORE_LOAD_ALL_FBS_SUCCESS */]:
        case types["_134" /* CORE_LOAD_ALL_TITLE_SUCCESS */]:
        case types["_128" /* CORE_LOAD_ALL_ROOMFORMATS_SUCCESS */]:
        case types["_131" /* CORE_LOAD_ALL_ROOMTYPE_SUCCESS */]:
        case types["_206" /* CORE_LOAD_SETTING_SUCCESS */]:
        case types["_245" /* CORE_UPDATE_SETTING_SUCCESS */]:
        case types["_236" /* CORE_SEARCH_EVENTS_SUCCESS */]:
        case types["_173" /* CORE_LOAD_PRIVATE_ROOM_SUCCESS */]:
        case types["_195" /* CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS */]:
        case types["p" /* CORE_CREATE_AMENITY_SUCCESS */]:
        case types["s" /* CORE_CREATE_BUILDING_SUCCESS */]:
        case types["_47" /* CORE_EDIT_BUILDING_SUCCESS */]:
        case types["_146" /* CORE_LOAD_DISABLE_ROOMS_SUCCESS */]:
        case types["_95" /* CORE_IMPORT_USER_FILE_SUCCESS */]:
        case types["_227" /* CORE_REOPEN_EVENT_SUCCESS */]:
        case types["_239" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */]:
        case types["_107" /* CORE_LOAD_ALL_AMENITY_SUCCESS */]:
        case types["_113" /* CORE_LOAD_ALL_DEPARTMENT_SUCCESS */]:
        case types["_143" /* CORE_LOAD_DEPARTMENT_SUCCESS */]:
        case types["_2" /* CORE_DELETE_DEPARTMENT_SUCCESS */]:
        case types["_191" /* CORE_LOAD_ROOMTYPE_SUCCESS */]:
        case types["_23" /* CORE_DELETE_ROOMTYPE_SUCCESS */]:
            return reducer__extends({}, state, {
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["X" /* CORE_DELETE_BUILDING_FAILURE */]:
        case types["_9" /* CORE_DELETE_FLOOR_FAILURE */]:
        case types["_168" /* CORE_LOAD_ORDERS_FAILURE */]:
        case types["_90" /* CORE_FIND_ROOM_FAILURE */]:
        case types["_24" /* CORE_DELETE_ROOM_FAILURE */]:
        case types["_222" /* CORE_LOAD_USER_FAILURE */]:
        case types["_246" /* CORE_UPDATE_USER_FAILURE */]:
        case types["_30" /* CORE_DELETE_USER_FAILURE */]:
        case types["_219" /* CORE_LOAD_USERS_FAILURE */]:
        case types["_99" /* CORE_LOAD_ALLROOM_FAILURE */]:
        case types["_240" /* CORE_UPDATE_ROOM_FAILURE */]:
        case types["_156" /* CORE_LOAD_FBS_FAILURE */]:
        case types["w" /* CORE_CREATE_FBS_FAILURE */]:
        case types["_120" /* CORE_LOAD_ALL_FLOOR_FAILURE */]:
        case types["I" /* CORE_CREATE_ROOM_FAILURE */]:
        case types["_102" /* CORE_LOAD_ALL_AMENITIES_FAILURE */]:
        case types["z" /* CORE_CREATE_FLOOR_FAILURE */]:
        case types["_165" /* CORE_LOAD_LOCAL_USERS_FAILURE */]:
        case types["a" /* BSRS_LOGIN_FAILURE */]:
        case types["h" /* CORE_CHANGE_PASSWORD_FAILURE */]:
        case types["R" /* CORE_CREATE_USER_FAILURE */]:
        case types["_66" /* CORE_EDIT_SYNC_FAILURE */]:
        case types["_231" /* CORE_RESET_PASSWORD_FAILURE */]:
        case types["_192" /* CORE_LOAD_ROOM_FAILURE */]:
        case types["_147" /* CORE_LOAD_DISABLE_ROOM_FAILURE */]:
        case types["_153" /* CORE_LOAD_EXECUTIVE_ROOM_FAILURE */]:
        case types["_180" /* CORE_LOAD_ROLE_FAILURE */]:
        case types["_114" /* CORE_LOAD_ALL_FBS_CATEGORY_FAILURE */]:
        case types["_108" /* CORE_LOAD_ALL_BUILDINGS_FAILURE */]:
        case types["_150" /* CORE_LOAD_EVENTREPORT_FAILURE */]:
        case types["e" /* CORE_CANCEL_EVENT_FAILURE */]:
        case types["_186" /* CORE_LOAD_ROOMS_FAILURE */]:
        case types["_117" /* CORE_LOAD_ALL_FBS_FAILURE */]:
        case types["_132" /* CORE_LOAD_ALL_TITLE_FAILURE */]:
        case types["_126" /* CORE_LOAD_ALL_ROOMFORMATS_FAILURE */]:
        case types["_129" /* CORE_LOAD_ALL_ROOMTYPE_FAILURE */]:
        case types["_204" /* CORE_LOAD_SETTING_FAILURE */]:
        case types["_243" /* CORE_UPDATE_SETTING_FAILURE */]:
        case types["_234" /* CORE_SEARCH_EVENTS_FAILURE */]:
        case types["_171" /* CORE_LOAD_PRIVATE_ROOM_FAILURE */]:
        case types["_193" /* CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE */]:
        case types["n" /* CORE_CREATE_AMENITY_FAILURE */]:
        case types["q" /* CORE_CREATE_BUILDING_FAILURE */]:
        case types["_45" /* CORE_EDIT_BUILDING_FAILURE */]:
        case types["_144" /* CORE_LOAD_DISABLE_ROOMS_FAILURE */]:
        case types["_93" /* CORE_IMPORT_USER_FILE_FAILURE */]:
        case types["_225" /* CORE_REOPEN_EVENT_FAILURE */]:
        case types["_237" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE */]:
        case types["_105" /* CORE_LOAD_ALL_AMENITY_FAILURE */]:
        case types["_111" /* CORE_LOAD_ALL_DEPARTMENT_FAILURE */]:
        case types["_141" /* CORE_LOAD_DEPARTMENT_FAILURE */]:
        case types["_0" /* CORE_DELETE_DEPARTMENT_FAILURE */]:
        case types["_189" /* CORE_LOAD_ROOMTYPE_FAILURE */]:
        case types["_21" /* CORE_DELETE_ROOMTYPE_FAILURE */]:
            var _action$payload = action.payload,
                statusText = _action$payload.statusText,
                code = _action$payload.code,
                message = _action$payload.message,
                data = _action$payload.data;

            if (data && data.code === "422") {
                message = data.message;
                code = data.code;
                statusText = data.code;
            }

            var returnData = reducer__extends({}, state, {
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            });
            return returnData;
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/features/users/reducer.js


var users_reducer_initialState = [];
/* harmony default export */ var users_reducer = ({
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["M" /* CORE_CREATE_SYNC_REQUEST */]:
            case types["_208" /* CORE_LOAD_SYNC_USER_REQUEST */]:
            case types["_67" /* CORE_EDIT_SYNC_REQUEST */]:
            case types["_16" /* CORE_DELETE_LOCAL_USERS_REQUEST */]:
                return users_reducer_initialState;
            case types["N" /* CORE_CREATE_SYNC_SUCCESS */]:
                return action.payload;
            case types["_209" /* CORE_LOAD_SYNC_USER_SUCCESS */]:
            case types["_68" /* CORE_EDIT_SYNC_SUCCESS */]:
            case types["_17" /* CORE_DELETE_LOCAL_USERS_SUCCESS */]:
                if (typeof action.payload !== "undefined") return action.payload;else return [{}];

            default:
                return state;
        }
    },
    system: function system() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_211" /* CORE_LOAD_SYSTEM_REQUEST */]:
                return users_reducer_initialState;

            case types["_212" /* CORE_LOAD_SYSTEM_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    localUsers: function localUsers() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_166" /* CORE_LOAD_LOCAL_USERS_REQUEST */]:
            case types["_217" /* CORE_LOAD_USERFILTER_REQUEST */]:
                return users_reducer_initialState;

            case types["_167" /* CORE_LOAD_LOCAL_USERS_SUCCESS */]:
            case types["_218" /* CORE_LOAD_USERFILTER_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    role: function role() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_181" /* CORE_LOAD_ROLE_REQUEST */]:
                return users_reducer_initialState;

            case types["_182" /* CORE_LOAD_ROLE_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    executive: function executive() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_154" /* CORE_LOAD_EXECUTIVE_ROOM_REQUEST */]:
                return users_reducer_initialState;

            case types["_155" /* CORE_LOAD_EXECUTIVE_ROOM_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    statusChangePassword: function statusChangePassword() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_229" /* CORE_REQUEST_CHANGE_PASSWORD_REQUEST */]:
                return users_reducer_initialState;
            case types["_230" /* CORE_REQUEST_CHANGE_PASSWORD_SUCCESS */]:
                if (typeof action.payload !== "undefined") return {
                    status: action.payload
                };else return {};
            default:
                return state;
        }
    },
    sendMailResetPassword: function sendMailResetPassword() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_238" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */]:
                return {};
            case types["_239" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */]:
                return {
                    status: action.payload
                };
            default:
                return {};
        }
    }
});
// CONCATENATED MODULE: ./src/features/rooms/reducer.js


var rooms_reducer_initialState = [];
/* harmony default export */ var rooms_reducer = ({
    floors: function floors() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_121" /* CORE_LOAD_ALL_FLOOR_REQUEST */]:
                return rooms_reducer_initialState;

            case types["_122" /* CORE_LOAD_ALL_FLOOR_SUCCESS */]:
                if (action.payload[0]) {
                    var payload = action.payload;
                    var floors = [];
                    payload.forEach(function (data) {
                        floors.push({ key: data._id, text: data.name, value: data._id });
                    });
                    return floors;
                }
                return action.payload;
            default:
                return state;
        }
    },
    amenities: function amenities() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_103" /* CORE_LOAD_ALL_AMENITIES_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_104" /* CORE_LOAD_ALL_AMENITIES_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    room: function room() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["J" /* CORE_CREATE_ROOM_REQUEST */]:
            case types["_196" /* CORE_LOAD_ROOM_REQUEST */]:
            case types["_64" /* CORE_EDIT_ROOM_REQUEST */]:
            case types["_25" /* CORE_DELETE_ROOM_REQUEST */]:
            case types["_148" /* CORE_LOAD_DISABLE_ROOM_REQUEST */]:
                return rooms_reducer_initialState;
            case types["K" /* CORE_CREATE_ROOM_SUCCESS */]:
            case types["_197" /* CORE_LOAD_ROOM_SUCCESS */]:
            case types["_65" /* CORE_EDIT_ROOM_SUCCESS */]:
            case types["_149" /* CORE_LOAD_DISABLE_ROOM_SUCCESS */]:
                return action.payload;
            case types["_26" /* CORE_DELETE_ROOM_SUCCESS */]:
                return {};

            default:
                return state;
        }
    },
    rooms: function rooms() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_187" /* CORE_LOAD_ROOMS_REQUEST */]:
            case types["l" /* CORE_CHANGE_QRCODE_REQUEST */]:
            case types["_88" /* CORE_FILTER_ROOM_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_188" /* CORE_LOAD_ROOMS_SUCCESS */]:
            case types["m" /* CORE_CHANGE_QRCODE_SUCCESS */]:
            case types["_89" /* CORE_FILTER_ROOM_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    roomsByType: function roomsByType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_194" /* CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_195" /* CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    disableRoom: function disableRoom() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_145" /* CORE_LOAD_DISABLE_ROOMS_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_146" /* CORE_LOAD_DISABLE_ROOMS_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    qrcode: function qrcode() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_175" /* CORE_LOAD_QRCODE_REQUEST */]:

                return rooms_reducer_initialState;
            case types["_176" /* CORE_LOAD_QRCODE_SUCCESS */]:

                return action.payload;

            default:
                return state;
        }
    },
    private_rooms: function private_rooms() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_172" /* CORE_LOAD_PRIVATE_ROOM_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_173" /* CORE_LOAD_PRIVATE_ROOM_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/fbs/reducer.js


var fbs_reducer_initialState = [];
/* harmony default export */ var fbs_reducer = ({
    fbs: function fbs() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["x" /* CORE_CREATE_FBS_REQUEST */]:
            case types["_157" /* CORE_LOAD_FBS_REQUEST */]:
            case types["_52" /* CORE_EDIT_FBS_REQUEST */]:
            case types["_7" /* CORE_DELETE_FBS_REQUEST */]:
                return fbs_reducer_initialState;

            case types["y" /* CORE_CREATE_FBS_SUCCESS */]:
            case types["_158" /* CORE_LOAD_FBS_SUCCESS */]:
            case types["_53" /* CORE_EDIT_FBS_SUCCESS */]:
            case types["_8" /* CORE_DELETE_FBS_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};

            default:
                return state;
        }
    },
    fbsList: function fbsList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_118" /* CORE_LOAD_ALL_FBS_REQUEST */]:
            case types["_79" /* CORE_FILTER_FBS_REQUEST */]:

                return fbs_reducer_initialState;

            case types["_119" /* CORE_LOAD_ALL_FBS_SUCCESS */]:
            case types["_80" /* CORE_FILTER_FBS_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [{}];

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/buildings/reducer.js


var buildings_reducer_initialState = [];
/* harmony default export */ var buildings_reducer = ({
    buildings: function buildings() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : buildings_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_109" /* CORE_LOAD_ALL_BUILDINGS_REQUEST */]:
            case types["_76" /* CORE_FILTER_BUILDING_REQUEST */]:
                return buildings_reducer_initialState;

            case types["_110" /* CORE_LOAD_ALL_BUILDINGS_SUCCESS */]:
            case types["_77" /* CORE_FILTER_BUILDING_SUCCESS */]:
                if (action.payload[0]) {
                    var payload = action.payload;
                    var buildings = [];
                    payload.forEach(function (data) {
                        buildings.push({
                            _id: data._id,
                            name: data.name
                        });
                    });
                    return buildings;
                }
                return action.payload;
            default:
                return state;
        }
    },
    building: function building() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : buildings_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_139" /* CORE_LOAD_BUILDING_REQUEST */]:
                return buildings_reducer_initialState;

            case types["_140" /* CORE_LOAD_BUILDING_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/fbsCategory/reducer.js


var fbsCategory_reducer_initialState = [];
/* harmony default export */ var fbsCategory_reducer = ({
    fbsCategory: function fbsCategory() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbsCategory_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_115" /* CORE_LOAD_ALL_FBS_CATEGORY_REQUEST */]:
                return fbsCategory_reducer_initialState;

            case types["_116" /* CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [{}];

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/floors/reducer.js


var floors_reducer_initialState = [];
/* harmony default export */ var floors_reducer = ({
    floor: function floor() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floors_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["A" /* CORE_CREATE_FLOOR_REQUEST */]:
            case types["_160" /* CORE_LOAD_FLOOR_REQUEST */]:
            case types["_55" /* CORE_EDIT_FLOOR_REQUEST */]:
            case types["_10" /* CORE_DELETE_FLOOR_REQUEST */]:
                return floors_reducer_initialState;

            case types["B" /* CORE_CREATE_FLOOR_SUCCESS */]:
            case types["_161" /* CORE_LOAD_FLOOR_SUCCESS */]:
            case types["_56" /* CORE_EDIT_FLOOR_SUCCESS */]:
            case types["_11" /* CORE_DELETE_FLOOR_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};

            default:
                return state;
        }
    },
    floorsList: function floorsList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floors_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_121" /* CORE_LOAD_ALL_FLOOR_REQUEST */]:
            case types["_82" /* CORE_FILTER_FLOOR_REQUEST */]:
                return floors_reducer_initialState;

            case types["_122" /* CORE_LOAD_ALL_FLOOR_SUCCESS */]:
            case types["_83" /* CORE_FILTER_FLOOR_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [{}];

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/holidays/reducer.js


var holidays_reducer_initialState = [];
/* harmony default export */ var holidays_reducer = ({
    holidays: function holidays() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : holidays_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_124" /* CORE_LOAD_ALL_HOLIDAYS_REQUEST */]:
                return holidays_reducer_initialState;
            case types["_125" /* CORE_LOAD_ALL_HOLIDAYS_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    holiday: function holiday() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : holidays_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_163" /* CORE_LOAD_HOLIDAY_REQUEST */]:
                return holidays_reducer_initialState;
            case types["_164" /* CORE_LOAD_HOLIDAY_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/amenity/reducer.js


var amenity_reducer_initialState = [];
/* harmony default export */ var amenity_reducer = ({
    amenity: function amenity() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["o" /* CORE_CREATE_AMENITY_REQUEST */]:
            case types["_136" /* CORE_LOAD_AMENITY_REQUEST */]:
            case types["_43" /* CORE_EDIT_AMENITY_REQUEST */]:
            case types["V" /* CORE_DELETE_AMENITY_REQUEST */]:
                return amenity_reducer_initialState;

            case types["p" /* CORE_CREATE_AMENITY_SUCCESS */]:
            case types["_137" /* CORE_LOAD_AMENITY_SUCCESS */]:
            case types["_44" /* CORE_EDIT_AMENITY_SUCCESS */]:
            case types["W" /* CORE_DELETE_AMENITY_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};

            default:
                return state;
        }
    },
    amenityList: function amenityList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_106" /* CORE_LOAD_ALL_AMENITY_REQUEST */]:
            case types["_73" /* CORE_FILTER_AMENITY_REQUEST */]:
                return amenity_reducer_initialState;

            case types["_107" /* CORE_LOAD_ALL_AMENITY_SUCCESS */]:
            case types["_74" /* CORE_FILTER_AMENITY_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [{}];

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/setting/reducer.js


var setting_reducer_initialState = [];
/* harmony default export */ var setting_reducer = ({
    setting: function setting() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setting_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_205" /* CORE_LOAD_SETTING_REQUEST */]:
                return setting_reducer_initialState;

            case types["_206" /* CORE_LOAD_SETTING_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/title/reducer.js


var title_reducer_initialState = [];
/* harmony default export */ var title_reducer = ({
    title: function title() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : title_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["P" /* CORE_CREATE_TITLE_REQUEST */]:
            case types["_214" /* CORE_LOAD_TITLE_REQUEST */]:
            case types["_70" /* CORE_EDIT_TITLE_REQUEST */]:
            case types["_28" /* CORE_DELETE_TITLE_REQUEST */]:
                return title_reducer_initialState;

            case types["Q" /* CORE_CREATE_TITLE_SUCCESS */]:
            case types["_215" /* CORE_LOAD_TITLE_SUCCESS */]:
            case types["_71" /* CORE_EDIT_TITLE_SUCCESS */]:
            case types["_29" /* CORE_DELETE_TITLE_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};

            default:
                return state;
        }
    },
    titleList: function titleList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : title_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_133" /* CORE_LOAD_ALL_TITLE_REQUEST */]:
                return title_reducer_initialState;

            case types["_134" /* CORE_LOAD_ALL_TITLE_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [{}];

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/report/reducer.js


var report_reducer_initialState = [];
/* harmony default export */ var report_reducer = ({
  // coreRoom: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_LOCATIONS_REPORT_REQUEST:
  //       return initialState

  //     case CORE_LOAD_LOCATIONS_REPORT_SUCCESS:
  //       if (action.payload[0]) {
  //         let payload = action.payload[0]
  //         let locations = []
  //         for (let i = 0; i < payload.length; i++) {
  //           locations.push({
  //             value: payload[i].email,
  //             key: i,
  //             text: payload[i].name,
  //             name: payload[i].name,
  //           })
  //         }
  //         return locations
  //       }
  //       else return [{}]

  //     default:
  //       return state
  //   }
  // },
  // statusSum: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_REPORTSUMMARY_REQUEST:
  //       return initialState

  //     case CORE_LOAD_REPORTSUMMARY_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  // roomReports: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_REPORT_REQUEST:
  //       return initialState
  //     case CORE_LOAD_REPORT_SUCCESS:
  //     let data = []
  //       if(action.payload !== ''){
  //         const {actionlog} = action.payload
  //         actionlog.data.forEach(payload => {
  //           let createEvent = false
  //           let updateEvent = false
  //           let deleteEvent = false
  //           let type = payload.meta.type
  //           if(type === "CREATE_EVENT") createEvent = true
  //           else if(type === "UPDATE_EVENT") updateEvent = true
  //           else deleteEvent = true
  //           data.push({
  //             startDateTimeThai: payload.meta.data.startDateTimeThai,
  //             endDateTimeThai: payload.meta.data.endDateTimeThai,
  //             organizerAddress:payload.meta.data.organizer.emailAddress.name,
  //             subject:payload.meta.data.subject,
  //             _id:payload._id,
  //             createEvent: createEvent,
  //             updateEvent:updateEvent,
  //             deleteEvent:deleteEvent,
  //             message:payload.meta.message,
  //             meetnow: payload.meta.meetnow ? true: false
  //           })
  //         });
  //         return data
  //       }
  //       return action.payload

  //     default:
  //       return state
  //   }
  // },
  // userReport: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_USERREPORT_REQUEST:
  //       return initialState

  //     case CORE_LOAD_USERREPORT_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  // roomReport: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_ROOMREPORT_REQUEST:
  //       return initialState

  //     case CORE_LOAD_ROOMREPORT_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  // userSum: (state = initialState, action) => {
  //   switch (action.type) {
  //     case CORE_LOAD_USERSUMMARY_REQUEST:
  //       return initialState

  //     case CORE_LOAD_USERSUMMARY_SUCCESS:
  //         let payload = action.payload
  //         let status = []
  //           status.push({
  //             reportHeader: payload.reportHeader,
  //             data: payload.data,
  //             summary : payload.summary
  //           })
  //         return status

  //     default:
  //       return state
  //   }
  // },
  eventReport: function eventReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_151" /* CORE_LOAD_EVENTREPORT_REQUEST */]:
        return report_reducer_initialState;
      case types["_152" /* CORE_LOAD_EVENTREPORT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  adminReport: function adminReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_97" /* CORE_LOAD_ADMINREPORT_REQUEST */]:
        return report_reducer_initialState;
      case types["_98" /* CORE_LOAD_ADMINREPORT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  searchEvents: function searchEvents() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_235" /* CORE_SEARCH_EVENTS_REQUEST */]:
        return report_reducer_initialState;
      case types["_236" /* CORE_SEARCH_EVENTS_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  eventAction: function eventAction() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["f" /* CORE_CANCEL_EVENT_REQUEST */]:
      case types["_226" /* CORE_REOPEN_EVENT_REQUEST */]:
        return report_reducer_initialState;
      case types["g" /* CORE_CANCEL_EVENT_SUCCESS */]:
      case types["_227" /* CORE_REOPEN_EVENT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/roomFormat/reducer.js


var roomFormat_reducer_initialState = [];
/* harmony default export */ var roomFormat_reducer = ({
    roomformats: function roomformats() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomFormat_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_127" /* CORE_LOAD_ALL_ROOMFORMATS_REQUEST */]:
            case types["_85" /* CORE_FILTER_ROOMFORMAT_REQUEST */]:
                return roomFormat_reducer_initialState;

            case types["_128" /* CORE_LOAD_ALL_ROOMFORMATS_SUCCESS */]:
            case types["_86" /* CORE_FILTER_ROOMFORMAT_SUCCESS */]:
                if (action.payload[0]) {
                    var payload = action.payload;
                    var buildings = [];
                    payload.forEach(function (data) {
                        buildings.push({
                            _id: data._id,
                            name: data.name
                        });
                    });
                    return buildings;
                }
                return action.payload;
            default:
                return state;
        }
    },
    roomformat: function roomformat() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomFormat_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_184" /* CORE_LOAD_ROOMFORMAT_REQUEST */]:
                return roomFormat_reducer_initialState;

            case types["_185" /* CORE_LOAD_ROOMFORMAT_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roomType/reducer.js


var roomType_reducer_initialState = [];
/* harmony default export */ var roomType_reducer = ({
    roomtypeInfo: function roomtypeInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomType_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_190" /* CORE_LOAD_ROOMTYPE_REQUEST */]:
                return roomType_reducer_initialState;
            case types["_191" /* CORE_LOAD_ROOMTYPE_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};
            default:
                return state;
        }
    },
    roomtype: function roomtype() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomType_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_130" /* CORE_LOAD_ALL_ROOMTYPE_REQUEST */]:
            case types["_202" /* CORE_LOAD_SEARCH_ROOMTYPE_REQUEST */]:
                return roomType_reducer_initialState;
            case types["_131" /* CORE_LOAD_ALL_ROOMTYPE_SUCCESS */]:
            case types["_203" /* CORE_LOAD_SEARCH_ROOMTYPE_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [];
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/department/reducer.js


var department_reducer_initialState = [];
/* harmony default export */ var department_reducer = ({
    department: function department() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : department_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_142" /* CORE_LOAD_DEPARTMENT_REQUEST */]:
                return department_reducer_initialState;
            case types["_143" /* CORE_LOAD_DEPARTMENT_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return {};
            default:
                return state;
        }
    },
    departmentsList: function departmentsList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : department_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_112" /* CORE_LOAD_ALL_DEPARTMENT_REQUEST */]:
            case types["_199" /* CORE_LOAD_SEARCH_DEPARTMENT_REQUEST */]:
                return department_reducer_initialState;
            case types["_113" /* CORE_LOAD_ALL_DEPARTMENT_SUCCESS */]:
            case types["_200" /* CORE_LOAD_SEARCH_DEPARTMENT_SUCCESS */]:
                if (action.payload) {
                    return action.payload;
                } else return [];
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/reducers.js




















/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["c" /* reducer */],
    notifications: Object(lib["reducer"])(),
    auth: reducer,
    ui: ui_reducer,
    user: users_reducer.user,
    system: users_reducer.system,
    localUsers: users_reducer.localUsers,
    statusChangePassword: users_reducer.statusChangePassword,
    sendMailResetPassword: users_reducer.sendMailResetPassword,
    floors: rooms_reducer.floors,
    amenities: rooms_reducer.amenities,
    room: rooms_reducer.room,
    rooms: rooms_reducer.rooms,
    qrcode: rooms_reducer.qrcode,
    fbs: fbs_reducer.fbs,
    fbsList: fbs_reducer.fbsList,
    amenity: amenity_reducer.amenity,
    amenityList: amenity_reducer.amenityList,
    buildings: buildings_reducer.buildings,
    building: buildings_reducer.building,
    fbsCategory: fbsCategory_reducer.fbsCategory,
    floorsList: floors_reducer.floorsList,
    floor: floors_reducer.floor,
    setting: setting_reducer.setting,
    holidays: holidays_reducer.holidays,
    holiday: holidays_reducer.holiday,
    title: title_reducer.title,
    titleList: title_reducer.titleList,
    role: users_reducer.role,
    disableRoom: rooms_reducer.disableRoom,
    executive: users_reducer.executive,
    eventReport: report_reducer.eventReport,
    roomformats: roomFormat_reducer.roomformats,
    roomformat: roomFormat_reducer.roomformat,
    adminReport: report_reducer.adminReport,
    searchEvents: report_reducer.searchEvents,
    eventAction: report_reducer.eventAction,
    private_rooms: rooms_reducer.private_rooms,
    roomsByType: rooms_reducer.roomsByType,

    roomtype: roomType_reducer.roomtype,
    roomtypeInfo: roomType_reducer.roomtypeInfo,

    department: department_reducer.department,
    departmentsList: department_reducer.departmentsList
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 780:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(649);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(678);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__(679);
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// CONCATENATED MODULE: ./src/lib/auth.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// export function setToken(token) {
//     localStorage.setItem('access-token', token)
// }

// export function getToken() {
//     return localStorage.getItem('access-token')
// }

// export function clearToken() {
//     localStorage.removeItem('access-token')
// }




var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var EXPIRES_ON = 'expires_on';
var REFRESH_TOKEN = 'refresh_token';
var SERVICE_TOKEN = 'service_token';
var ROLE = 'isAdmin';
var API_URL = 'api_server_url';
var CLIENT_ID = 'client_id';
var SERVICE_TOKEN_EXPIRES = 'service_token_expires_on';
var USER_ID = 'userId';
var RESULT_PER_PAGE = 'result_per_page';
var IS_FIRST_CHANGE_PASSWORD = 'isFirstChangePassword';
var CURRENT_PAGE = 'currentPage';

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value) {
    js_cookie_default.a.set(key, value);
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getAccessToken() {
    return getCookie(ACCESS_TOKEN);
}

function getService() {
    return getCookie({ CLIENT_ID: CLIENT_ID, API_URL: API_URL });
}
function getIsFirstChangePassword() {
    return getCookie(IS_FIRST_CHANGE_PASSWORD);
}

function getResultPerPage() {
    var resultPerPage = parseInt(getCookie(RESULT_PER_PAGE), 10);
    return !isNaN(resultPerPage) ? resultPerPage : 10;
}
function getAllToken() {
    if (!getCookie(ACCESS_TOKEN)) return {};
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN),
        isFirstChangePassword: getCookie(IS_FIRST_CHANGE_PASSWORD)
    };
}

function setToken(_ref) {
    var access_token = _ref.access_token,
        expires_on = _ref.expires_on,
        refresh_token = _ref.refresh_token,
        result_per_page = _ref.result_per_page,
        isFirstChangePassword = _ref.isFirstChangePassword;

    setCookie(ACCESS_TOKEN, access_token);
    setCookie(EXPIRES_ON, expires_on);
    setCookie(REFRESH_TOKEN, refresh_token);
    setCookie(RESULT_PER_PAGE, result_per_page);
    setCookie(IS_FIRST_CHANGE_PASSWORD, isFirstChangePassword);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(ROLE);
    removeCookie(REFRESH_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(RESULT_PER_PAGE);
    removeCookie(IS_FIRST_CHANGE_PASSWORD);
}

function getServiceToken() {
    if (!getCookie(SERVICE_TOKEN)) return {};
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES)
    };
}

function setServiceToken(_ref2) {
    var token = _ref2.token,
        expires_on = _ref2.expires_on,
        result_per_page = _ref2.result_per_page;

    if ((typeof token === 'undefined' ? 'undefined' : _typeof(token)) !== undefined) setCookie(SERVICE_TOKEN, token);
    if ((typeof expires_on === 'undefined' ? 'undefined' : _typeof(expires_on)) !== undefined) setCookie(SERVICE_TOKEN_EXPIRES, expires_on);
    setCookie(RESULT_PER_PAGE, result_per_page);
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    var _jwt$decode = jsonwebtoken_default.a.decode(access_token),
        iat = _jwt$decode.iat,
        exp = _jwt$decode.exp,
        appid = _jwt$decode.appid,
        name = _jwt$decode.name,
        email = _jwt$decode.unique_name;

    return {
        iat: iat,
        exp: exp,
        appid: appid,
        name: name,
        email: email
    };
}

function getBSRSToken() {
    var returnData = { bsrsToken: getCookie(BSRS_ACCESS_TOKEN), role: getCookie(ROLE), userId: getCookie(USER_ID) };
    return returnData;
}

function setBSRSToken(_ref3) {
    var token = _ref3.token,
        role = _ref3.role,
        userId = _ref3.userId,
        result_per_page = _ref3.result_per_page,
        isFirstChangePassword = _ref3.isFirstChangePassword;

    clearBSRSToken();
    setCookie(BSRS_ACCESS_TOKEN, token);
    setCookie(ROLE, role);
    setCookie(USER_ID, userId);
    setCookie(RESULT_PER_PAGE, result_per_page ? result_per_page : 10);
    setCookie(IS_FIRST_CHANGE_PASSWORD, isFirstChangePassword);
}

function setCurrentPage(page) {
    setCookie(CURRENT_PAGE, page);
}
function getCurrentPage() {
    return parseInt(getCookie(CURRENT_PAGE), 10);
}
function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(ROLE);
    removeCookie(API_URL);
    removeCookie(CLIENT_ID);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(USER_ID);
    removeCookie(RESULT_PER_PAGE);
    removeCookie(IS_FIRST_CHANGE_PASSWORD);
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var loadFile = "*File size limit = 10 MB";
var LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm';
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(36);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var react_router_dom_es = __webpack_require__(135);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(163);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(166);

// CONCATENATED MODULE: ./src/lib/withAuthCheck.js







var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: api["b" /* PREFIX */] + '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return {
      isLoggedIn: Object(selectors["b" /* getIsLoggedIn */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withAuthCheckO365.js






var withAuthCheckO365_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/logino365' });
};
var withAuthCheckO365_withAuthCheckO365 = function withAuthCheckO365(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheckO365 = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheckO365'), Object(es["connect"])(function (state) {
    return {
      isLoggedInO365: Object(selectors["c" /* getIsLoggedInO365 */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedInO365 = _ref.isLoggedInO365;
    return isLoggedInO365;
  }, withAuthCheckO365_withAuthCheckO365, Object(Recompose["d" /* renderComponent */])(withAuthCheckO365_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withO365UserInfo.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var withO365UserInfo_withO365UserInfo = function withO365UserInfo(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, _extends({}, props, { O365UserInfo: props.userInfo }));
  };
};

/* harmony default export */ var lib_withO365UserInfo = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withO365UserInfo'), Object(es["connect"])(function (state) {
    return {
      userInfo: Object(selectors["d" /* getUserInfo */])(state)
    };
  }), withO365UserInfo_withO365UserInfo)(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["b" /* PREFIX */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getCookie; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setCookie; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return removeCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getAccessToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getService; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsFirstChangePassword; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return getResultPerPage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return getAllToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return setToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return getServiceToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return setServiceToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return setBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setCurrentPage; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getCurrentPage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return clearBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return timeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return loadFile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return LongDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return lib_withAuthCheck; });
/* unused concated harmony import withAuthCheckO365 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheckO365; });
/* unused concated harmony import withO365UserInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withO365UserInfo; });







/***/ })

},[654]);


// WEBPACK FOOTER //
// app.6d0a64ad2a123bdde306.js